export default {
  default: 'en',
  SystemBar: {
    DownloadApp: 'Download the App',
    ContactUs: 'Contact Us',
    AboutUs: 'About Us',
    Help: 'Customer Service',
    OpenShop: 'Open a Shop',
    RegisterPartner: 'Register as a Partner',
    GoToNexGen: 'Go to NexGen App?',
    WebstieWantToNexGen: 'This website needs to open the NexGen app.',
    GoToNexGenSeller: 'Go to NexGen Seller App?',
    WebstieWantToNexGenSeller: 'This website needs to open the NexGen Seller app.',
    Go: 'Next',
    chatWithAdmin: 'Chat with Admin',
    LoginBeforeChat: 'Please log in before chatting with admin.'
  },
  DialogDownloadApp: {
    ForBuyer: '(For Buyer)',
    ForSeller: '(For Seller)',
    textDownload: 'Download the app now by'
  },
  AppBar: {
    Search: 'Search for products and shops',
    Register: 'Sign Up',
    or: 'or',
    Login: 'Login',
    RegisterLogin: 'Register/Login',
    LoginShopPurchaser: 'Login Shop/Purchaser',
    SearchNoJV: 'Search Products',
    SearchJV: 'Search Products in Shop',
    ViewCart: 'View your carts',
    NoCart: 'There are no products in your cart.',
    sku: 'SKU',
    Quantity: 'quantity',
    SearchGroup: 'Search products and shops in group'
  },
  Maintain: {
    header: 'Sorry, The website is under maintenance.'
  },
  Notification: {
    notification: 'Notification',
    noNotification: 'No Notification',
    textNoNoti: 'Notifications will appear here when you receive messages.',
    AllNotifications: 'All Notifications',
    ReadAll: 'Read All',
    New: 'New',
    Before: 'Before'
  },
  TextHome: {
    textRecommend: 'Recommend!',
    textProduct: 'Products for you',
    ViewAllProducts: 'View All Products',
    ViewAll: 'View All',
    textSearch: 'Please enter a search term.'
  },
  Footer: {
    Account: 'Account',
    Chat: 'Chat',
    Shop: 'Shop',
    Payment: 'Payment',
    Shipping: 'Shipping',
    CustomerService: 'Customer Service',
    Detail: {
      Account: 'Keep your user account safe with One ID.',
      Chat: 'You can chat with sellers anytime via our One Chat system.',
      Shop: 'Select the items you desire from our website.',
      Payment: 'Make a payment using your credit card via Thaidotcom payment.',
      Shipping: 'We ensure fast and safe delivery of your products directly to you.',
      CustomerService: 'Our efficient after-sales service ensures your confidence in our products.'
    },
    HeadOffice: 'Head Office',
    HelpCenter: 'Help Center',
    Categories: 'Categories',
    PaymentMethods: 'Payment Methods',
    FollowUs: 'Follow Us',
    aboutAs: 'About As',
    Certification: 'Certification',
    DetailAddress: {
      Company: 'Nex Gen Shop Co., Ltd.',
      INET: 'A subsidiary of Internet Thailand Public Company Limited',
      Address: '1768 Thai Summit Tower, 16th Floor, New Petchburi Road, Bangkapi, Huai Khwang, Bangkok 10310',
      Phone: 'Phone: 02-257-7155 ext. 5',
      Email: 'Email: team@nexgenshop.co.th'
    },
    DetailAbout: {
      Policy: 'Policy',
      TermsOfUse: 'Terms of Use',
      DeletingUserData: 'Deleting User Data',
      AboutUs: 'About Us',
      ManualForLogin: 'User Registration and Login Guide'
    },
    DetailPayment: {
      Payment: 'Thai Dotcom Payment'
    }
  },
  Menu: {
    Language: 'Language',
    Profile: 'My Account',
    Orders: 'My Orders',
    Select: 'Select Role',
    DetailSelect: {
      Buyer: 'Buyer',
      Purchaser: 'Purchaser',
      Seller: 'Seller',
      Sales: 'Sales',
      Admin: 'Admin',
      Approver: 'Approver',
      AdminSystem: 'Admin NGC'
    },
    BusinessEntity: 'Business Info',
    Company: 'Company Info',
    Shops: 'Shops',
    ShopRegister: 'Create Shop',
    Logout: 'Log Out'
  },
  Headers: {
    Home: 'Home Page',
    RecommendedProducts: 'Recommended Products',
    RecommendedForYou: 'Recommended for You',
    Detail: {
      Categories: 'Product Categories',
      Category: 'Categories',
      AllCategories: 'All Categories',
      Price: 'Price'
    },
    ProductText: {
      Popular: 'Popular Products',
      FlashSale: 'Flash Sale',
      NoCategory: 'No Product Category',
      NoProduct: 'No Products Available',
      NewProducts: 'New Products',
      BestSeller: 'Best Sellers Products',
      SameShop: 'Products from the Same Shop',
      All: 'All Products',
      SameCategory: 'Products from the Same Category',
      RelatedCategory: 'Related Categories Products',
      Product: 'Product',
      Products: 'Products',
      bundleDeal: 'Bundle Deal Products',
      MaxDiscountBundle: "Items are complete, you've hit the maximum discount",
      CheckMoreItem: 'Please add no more than',
      MoreItems: 'there are more items than are included in the promotion.',
      MaxItems: 'Up to max savings. Buy now!',
      DetailSetDeal: 'Product Details / Promotional Discounts',
      BestSet: 'Best Value Set'
    },
    HomeText: {
      RecommendedProducts: 'Recommended Products',
      NewProducts: 'New Products',
      BestSeller: 'Best Sellers Products',
      NoRecommendedProducts: 'No recommended products available yet',
      NoBestSellers: 'No best-selling products available yet',
      NoNewArrivals: 'No new arrival products available yet',
      ViewAll: 'View All',
      Shops: 'Shops',
      AllShops: 'All Shops'
    }
  },
  userProfileNewUI: {
    UserProfile: 'My Information',
    MyAccount: 'My Account',
    Edit: 'Edit',
    Cancel: 'Cancel',
    Save: 'Save',
    Confirm: 'Confirm',
    PersonalInformation: 'Personal Information',
    FirstName: 'Name',
    LastName: 'Surname',
    Phone: 'Phone Number',
    Email: 'Email',
    EnterFirstName: 'Enter Name',
    EnterLastName: 'Enter Surname',
    EnterPhone: 'Enter Phone',
    EnterEmail: 'Enter Email',
    BankName: 'Bank Name',
    BankAccountNumber: 'Bank Account Number',
    BankAccountName: 'Bank Account Name',
    BankAccountBranch: 'Bank Account Branch',
    EditUserProfile: 'Edit My Information',
    CheckedInformation: 'Please confirm that all information is correct before proceeding.',
    OnlyLetterEnter: 'Only letters can be enter',
    PleaseEnterName: 'Please enter your name',
    NotEnterMoreName: 'Do not enter more than 30 characters in your name',
    PleaseEnterSurName: 'Please enter your surname',
    NotEnterMoreSurName: 'Do not enter more than 30 characters in your surname',
    NoUsername: 'No Username',
    NoFullname: 'No Name - Surname',
    PleaseAddImage: 'Please add only image files (JPEG, JPG, PNG)',
    UnableProceed: 'Unable to proceed',
    EditSuccess: 'Information updated successfully.',
    SuccessEditYourData: 'You have successfully updated your information.'
  },
  ShoppingCartUI: {
    ShoppingCart: 'Shopping Cart',
    Home: 'Home',
    NoProduct: "Don't have product in your cart",
    GoShop: 'Back to store',
    GoBuy: "Let's go shopping",
    RemoveSelectItems: 'Remove Selected Item',
    Store: 'Store',
    StoreNosell: 'Store not ready',
    DetailProduct: 'Product Details',
    UnitPrice: 'Unit Price',
    Quantity: 'Quantity',
    TotalPrice: 'Total Price',
    CannotPurchaseTogether: "Services and general products can't be purchased together",
    Delete: 'Delete',
    NotReady: 'not ready',
    SoldOut: 'sold out',
    ProductCannotReduce: "Product quantity can't be reduced",
    item: 'item',
    items: 'items',
    DueMinimumOrder: 'Due to the minimum order quantity of',
    ItemLeftTH: '',
    ItemLeftEN: 'left',
    PreOrder: 'Pre-order',
    StoreDiscountCoupon: 'Apply Shop Coupon',
    StoreDiscountPoint: 'Use Seller Points',
    GeneralProduct: 'General Products',
    B2BProduct: 'B2B',
    ProductCannotIncrease: "Product quantity can't be increased",
    DueMaximumOrder: 'Due to the maximum order quantity of',
    Free: 'free',
    StoreDiscount: 'Use store discount, reduce',
    ShippingDiscount: 'Use shipping discount, reduce',
    PointsDiscount: 'Use points discount',
    SystemDiscountCoupon: 'Nexgen Discount',
    UseSystemDiscount: 'Discount',
    Discount: 'Discount',
    OrderSummary: 'Order Summary',
    PriceExcludingVAT: 'VAT-exclusive items',
    VAT: 'VAT',
    PriceIncludingVAT: 'VAT-inclusive items',
    Baht: 'baht',
    Month: 'month',
    TotalPriceAll: 'Total Amount',
    StoreDiscountSummary: 'Seller Discount',
    ShippingDiscountSummary: 'Shipping Discount',
    PointsDiscountSummary: 'Point Discount',
    BundleDealDiscountSummary: 'Bundle Deal Discount',
    SystemDiscountSummary: 'Nexgen Discount',
    PriceAfterDiscount: 'Subtotal',
    PartnerDiscount: 'Partner Discount',
    CustomerDiscount: 'Customer Discount',
    PriceAfterPartnerDiscount: 'Price (after partner discount)',
    ProductPriceIncludingDiscount: 'Product Price (including discount)',
    ThisPriceStandardPriceVary: 'This price is a standard rate - the actual price may vary depending on',
    DependingProductDestination: 'the item/destination. The delivery staff will contact you',
    PointsEarnedThisTime: 'Nexgen Poins Earned',
    Points: 'Points',
    OrderProducts: 'Checkout',
    DeleteProduct: 'Delete product',
    HaveDeletedProduct: 'You have deleted product',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    ShippingFee: 'Shipping Fee',
    ConfirmTransaction: 'Confirm this transaction?',
    TotalPointsEarnedThisTime: 'Nexgen Poins Earned All',
    PointsEarned: 'Points received',
    TotalPointsEarned: 'Total Points',
    LargeProduct: '*Large product',
    ProductChanged: '*Product has changed, please remove from cart',
    OutStock: 'Out of stock',
    InsufficientStock: 'Insufficient stock',
    AddProductCart: 'Please add product to cart',
    UnableProceed: 'Unable to proceed',
    CartAddedMaximum: 'The cart can only be added to a maximum of 150 items',
    NotConditionsDiscountProductPriceLessMinimumPrice: 'Does not meet the conditions for using the discount because the product price is less than the minimum price specified by the coupon',
    CouponOutStock: "This coupon can't be used because this coupon is out of stock",
    CouponReserved: "This coupon can't be used because this coupon has been reserved",
    ServerError: 'Server Error',
    ChangedRemoveCartAddItem: 'This has changed. Please remove from cart and re-add the item',
    NoStockRemoveCart: 'No stock. Please remove from cart',
    InsufficientStockRemoveCart: 'Insufficient stock. Please remove from car',
    ProductID: 'Product ID',
    WantDeleteItem: 'Do you want to delete the item?',
    QuantityLessSpecified: 'Quantity less than specified',
    ChangedRemoveCart: 'This has changed. Please remove from cart',
    CartRemoveSuccess: 'Cart has been removed successfully',
    OK: 'Confirm',
    LessSpecifiedQuantity: 'Less than specified quantity',
    MoreSpecifiedQuantity: 'More than specified quantity',
    CannotIncreaseQuantityItemsSpecifiedQuantity: "Can't increase the quantity of items because you have already added the specified quantity",
    LargeShippingOnlyItem: 'Since this item uses the Large shipping method, you can only order 1 item at a time',
    TotalPriceLess: 'The total price should not be less than 1 baht',
    PleaseSelect: 'Please select',
    NewAgain: 'New again',
    UsePoints: 'Use points',
    PointsScore: 'Points',
    NoShopIDNGS: 'There is no ShopID in NGS',
    NoRecommendedItems: 'There are no recommended items',
    BestDeal: 'Best Deal',
    CODFee: 'COD Fee',
    verifyBy: 'Verify By',
    verifyByThaID: 'Verify By ThaID',
    verifyByHEALTHID: 'Verify By HEALTH ID',
    changeAddOn: 'Change Add On'
  },
  Coupon: {
    Coupon: 'Coupon',
    Coupons: 'Coupons',
    GeneralDiscount: 'General shop Discount Coupon',
    NoGeneralDiscount: 'General shop coupons are not available yet.',
    StoreSpecific: 'Shop-only Coupon',
    NoStoreSpecific: 'No Shop-Only Coupons Available yet.',
    ForStore: 'For shop',
    Only: 'Only',
    Conditions: 'Coupon Conditions',
    PromotionType: 'Promotion Type',
    ShippingDiscount: 'Shipping Discount',
    ProductDiscount: 'Product Price Discount',
    UsageRight: 'Coupon Usage Rights',
    Usable: 'Can be used',
    Rights: 'Rights',
    MaxDiscount: 'Maximum Discount',
    MaxReduce: 'Maximum Discount ',
    Currency: ' Baht',
    Unlimited: 'Unlimited',
    ParticipatingStores: 'Participating Stores',
    AllStores: 'All Participating Stores',
    Shop: 'Shop',
    ValidEverywhere: 'Valid at All Stores',
    MinSpend: 'Min. Spend',
    MaxSpend: 'Up to',
    ValidUntil: 'Valid Until',
    ValidFrom: 'Valid From',
    ValidOn: 'Valid On',
    NoExpiry: 'No Expiration Date',
    ViewConditions: 'View Conditions',
    Claim: 'Claim',
    Claimed: 'Claimed',
    ClaimCoupon: 'Claim',
    ClaimedCoupon: 'Claimed',
    ClaimAll: 'Claim All',
    ShowMore: 'Show More',
    ShowLess: 'Show Less',
    CouponDescription: 'Coupon Description',
    ViewConditionsShop: 'View Conditions',
    SpacialShop: 'Use for shop'
  },
  CheckOut: {
    TypeAddress: 'Address Type',
    ShippingAddress: 'Shipping Address',
    ChangeAddress: 'Change Address',
    Notation: 'Notation',
    IncompleteAddress: 'Address incomplete. Please choose others address.',
    AddAddress: 'Add Address',
    OrderList: 'Checkout',
    QuotationSample: 'Quotation Sample',
    ShopName: 'Store',
    UseCouponShop: 'Use Coupon Shop',
    GeneralProduct: 'General Products',
    ServiceProduct: 'Service Products',
    ApplyStoreVoucher: 'Apply Store Voucher',
    ApplyStoreVoucherMobile: 'Apply Store Voucher',
    FreeShipping: 'Free Shipping',
    FreeShippingMobile: 'Free Shipping',
    UseStorePoint: 'Use Seller Points',
    Free: 'Free',
    Discount: 'Discount',
    AddressTaxInvoiceIssuance: 'Address for tax invoice issuance',
    ReceiveTaxInvoice: 'Receive a tax invoice',
    NotReceiveTaxInvoice: 'Not receive a tax invoice',
    BranchCode: 'Branch code',
    TaxNumber: 'Tax Number',
    Address: 'Address',
    ShippingType: 'Shipping Type',
    PickUpAStore: 'Pick up at the store',
    ProductDelivery: 'Product delivery',
    ChooseShipping: 'Choose Shipping',
    ChooseOtherShipping: 'Choose Other Shipping',
    SentByStore: 'Sent By Store',
    HouseNumber: 'House Number',
    SubDistrict: 'SubDistrict',
    District: 'District',
    Province: 'Province',
    ReceivingDate: 'Receiving Date',
    ReceivingTime: 'Receiving Time',
    UnitPrice: 'Unit price',
    Quantity: 'Quantity',
    TotalPrice: 'Total Price',
    PricePerMonth: 'THB/month',
    SKU: 'SKU',
    SystemDiscountCoupon: 'Nexgen Discount',
    UseSystemDiscountCoupon: 'Discount',
    DiscountCoupon: 'Discount',
    DiscountShipping: 'Free Shipping',
    Relationships: 'Relationships',
    RelationshipsCoupon: 'Partnership',
    ChangeRelationshipsCoupon: 'Change',
    PriceExcludingVAT: 'VAT-exclusive items',
    VAT: 'VAT',
    Baht: 'Baht',
    PriceIncludingVAT: 'Total (Incl. VAT)',
    SummaryOrdered: 'Order Summary',
    CouponDiscountSeller: 'Seller Discount',
    CouponDiscountNexgen: 'Nexgen Discount',
    NexgenPointDiscount: 'Point Discount',
    BundleDealDiscount: 'Bundle Deal Discount',
    SubTotal: 'Subtotal',
    ShippingFee: 'Shipping Fee',
    ShippingCostDesicription1: 'This price is a standard rate - the actual price may vary depending on',
    ShippingCostDesicription2: 'the item/destination. The delivery staff will contact you',
    ShippingDiscountSeller: 'Shipping Discount Seller',
    ShippingDiscountNexgen: 'Shipping Discount Nexgen',
    CreditCardInstallmentOption: 'Credit Card with Installment Option',
    SelectPaymentMethod: 'Payment Method',
    InstallmentPaymentNotAvailableBecause: 'Installment payment is not available because the',
    RequiredAmountHasNotBeenMet: 'required amount has not been met',
    SelectInstallmentPeriod: 'Select Installment Period',
    Krungthai: 'Krungthai (KTC)',
    PointsEarned: 'Points earned this time',
    Point: 'Point',
    TotalPriceAll: 'Total Price',
    ConfirmOrder: 'Confirm Order',
    ComfirmModal: 'Do you want to proceed with this transaction? Yes or No',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    PleaseWaitSellerApproveOrder: 'Please wait for the seller to approve your order',
    OrderConfirmationCompleted: 'Order confirmation completed',
    ConfirmDeleteAddress: 'Delete shipping address',
    ShippingAddressDeletedSuccessfully: 'Shipping address deleted successfully',
    YourOrderHasBeenPlacedSuccessfully: 'Your order has been placed successfully',
    YouHaveSuccessfullyDeletedTheShippingAddress: 'You have successfully deleted the shipping address',
    GoOrderListPage: 'Go to Order List Page',
    GoToHomePage: 'Go to Home Page',
    GoQuotationPage: 'Go to Quotation Page',
    ChangeShippingAddress: 'Change Shipping Address',
    Edit: 'Edit',
    Delete: 'Delete',
    NoAddress: 'No Shipping Address',
    SelectShippingMethod: 'Select Shipping Method',
    StartingShippingFee: 'Starting Shipping Fee',
    ChangeBillingAddressInvoice: 'Change Billing Address for Invoice',
    TaxInvoiceAddress: 'Tax Invoice Address',
    Individual: 'Individual',
    JuristicPerson: 'Juristic Person',
    DefaultAddress: 'Default Address',
    ScanQRCodeMakePayment: 'Pay the store by scanning the QR Code',
    ScanQRCodeToPay: 'Pay by scanning the QR Code',
    SaveImage: 'Save Image',
    TotalPaymentAmount: 'Total Payment Amount',
    CanMakePaymentByFollowingStep: 'You can make a payment by following these steps (for mobile payment)',
    SaveImageStep1: 'Tap the "Save Image" button or take a screenshot',
    ForIOSDevices: 'For iOS devices',
    TakeScreenshot: 'Take a screenshot or tap and hold the image',
    TapTheButton: ', then tap the button',
    OpenYourBankingApp: 'Open your banking app and select the "Scan QR Code" menu',
    SelectScreenshotScanTheQRCode: 'Select the screenshot and scan the QR Code',
    RefID: 'Reference Code',
    RequestQuotationEdit: 'Request Quotation Edit',
    EditCouponDisscription: 'Discount coupons cannot be applied to the revised quotation until it is approved by the seller',
    EditCouponConfirm: '"Confirm to proceed or not"',
    DeleteTaxInvoiceAddress: 'Delete Tax Invoice Address',
    ConfirmDelectTaxInvoiceAddress: 'Do you want to proceed with this action? Yes or No',
    DeleteAddressSuccessfully: 'Delete Address Successfully',
    UnableToDelete: 'Unable to delete',
    AddressCurrentlyUse: 'This billing address is currently in use',
    YouHaveSuccessfullyDeletedTaxInvoiceAddress: 'You have successfully deleted the tax invoice address',
    TotalPointsEarnedInThisTransaction: 'Total points earned in this transaction',
    Store: 'Store',
    PointEarned: 'Point Earned',
    TotalPoint: 'Total Point',
    HomePage: 'Home Page',
    ShoppingCart: 'Shopping Cart',
    OperatingBudget: 'Operating Budget',
    investmentBudget: 'Investment Budget',
    regularExpenditureBudget: 'Regular Expenditure Budget',
    COGS: 'COGS',
    SGnA: 'SG&A',
    RnD: 'R&D',
    Month: 'Month',
    PleaseEnterYourFullName: 'Please enter your full name',
    PleaseEnterYourPhoneNumber: 'Please enter your phone number',
    PleaseEnterValidPhoneNumber: 'Please enter a valid phone number',
    PleasEnterYourPosition: 'Please enter your position',
    PleaseEnterYourEmailAddress: 'Please enter your email address',
    PleaseEnterValidEmailAddress: 'Please enter a valid email address',
    ProductDetails: 'Product Details',
    RedeemPoints: 'Redeem',
    Points: 'Points',
    TheCartHasBeenUpdated: 'The cart has been updated',
    PleaseEnterTheShippingAddress: 'Please enter the shipping address',
    ToViewsampleQuotation: 'to view the sample quotation',
    PleaseEnterTheAddressForTheTaxTnvoice: 'Please enter the address for the tax invoice',
    ToViewSampleQuotation: 'to view the sample quotation',
    UnavailableSampleQuotation: 'The system is unavailable to view the sample quotation',
    FailedToDeleteTheShippingAddress: 'Failed to delete the shipping address',
    SetAsDefaultAddressSuccessfully: 'Set as default address successfully',
    FailedToSetAsDefaultAddress: 'Failed to set as default address',
    AddShippingAddress: 'Add Shipping Address',
    EditShippingAddress: 'Edit Shipping Address',
    SelectAddressFirst: 'Please select a shipping address first, or complete/add a shipping address before proceeding',
    Phone: 'Telephone',
    SystemErrorHasOccurredPleaseContactSupport: 'A system error has occurred please contact support',
    EditTaxInvoiceAddress: 'Edit Tax Invoice Address',
    AddTaxInvoiceAddress: 'Add Tax Invoice Address',
    PleaseSelectShippingMethodStoreDelivery: "Please select a shipping method for the store's delivery",
    NoTaxInvoiceAddressAvailable: 'No tax invoice address available',
    SomeItemsAreNotEligibleForTheFreeGiftDueToInsufficientQuantity: 'Some items are not eligible for the free gift due to insufficient quantity:',
    PleaseRemoveTheseItemsFromYourCart: 'Please remove these items from your cart',
    ShoppingCartNotFound: 'Shopping Cart Not Found',
    SomeItemsAreNoLongerAvailableInTheSystem: 'Some items are no longer available in the system:',
    PleaseRemoveThemFromYourCart: 'Please remove them from your cart',
    SomeItemsAreNotAvailableInSufficientQuantityForPurchase: 'Some items are not available in sufficient quantity for purchase:',
    TheTotalPriceMustBeGreaterThanZerobaht: 'The total price must be greater than 0 baht',
    PleaseEnterDiscountThatDoesNotExceedTheProductPricel: 'Please enter a discount that does not exceed the product price',
    YouHaveNotAddedAnAddressYet: 'You have not added an address yet',
    Incompleteinformation: 'Incomplete information',
    PleaseConfirmYourOrderAgain: 'Please confirm your order again',
    WeightOver50kilograms: 'The total weight of your items exceeds 50 kilograms. If you would like to place an order, please contact our staff. Thank you.',
    UserPermissionsChange: 'Please check again, as there has been a change in user permissions',
    TheCouponCanBeUsed: 'The coupon can be used',
    TheCouponCannotBeUsed: 'The coupon cannot be used',
    Paymentincomplete: 'Payment Incomplete',
    ModalShippingIMG: require('@/assets/shippingbannermini_en.png'),
    ShippingBanner: require('@/assets/shippingbannermini_en.png'),
    NoteToStore: 'Note to Store (Not Required)',
    COD: 'Cash on Delivery (COD)',
    ProvidesInsurance: 'The store provides a product insurance for you.',
    ShippingInsurance: 'Shipping Insurance',
    InsuranceDiscription: 'I would like to purchase shipping insurance to protect my goods from accidents, damage, or loss during transit.',
    MoreDetails: 'More Details',
    InsuranceDetailModalP1: 'In the event that an item is damaged or lost and such damage or loss falls under the responsibility of the shipping service provider, the provider will compensate for the actual value of the damage or loss, but not exceeding 2,000 THB per item. If you require a higher compensation limit, you may opt for additional insurance coverage, for which an extra service fee must be paid according to the desired insured amount.',
    InsuranceDetailModalP2: 'The shipping service provider shall not be liable for any damage or loss arising from inadequate or improper packaging, or from any cause that is not the responsibility of the shipping service provider, including force majeure events. In addition, the item must not be a prohibited item under the terms and conditions of the shipping service provider.',
    Close: 'Close',
    ShippingInsuranceCanUse: 'Shipping insurance can be used',
    InsurancePrice: 'Insurance Price',
    CODFee: 'COD Fee',
    TitleBundleTh: 'Special Price Products',
    BestDeal: 'Best Deal',
    SelectShippingLalamove: 'Select address and select transport',
    ShippingBannerLalamove: require('@/assets/shippingBannerLalamove.png'),
    TypeCar1: 'Urgent small package delivery.',
    TypeCar2: 'Small to medium-sized cargo delivery requiring special handling.',
    TypeCar3: 'Medium-sized cargo delivery requiring special handling.',
    TypeCar4: 'Large cargo delivery requiring special handling.',
    TypeCar5: 'Four-door pickup truck without a canopy for transporting large cargo.',
    TypeCar6: 'Pickup truck without a canopy for transporting large cargo.',
    TypeCar7: 'Pickup truck with a canopy for transporting large cargo.',
    TypeCar8: 'Pickup truck with a high steel frame for extra-tall and heavy cargo.',
    TypeCar9: 'Box truck (enclosed pickup) suitable for large cargo.',
    UnitMeter: 'meter',
    MaxWeight: 'Weight not exceeding',
    UnitKg: 'Kg',
    SelectTypeCar: 'Select Car Type',
    BackButton: 'Back',
    ConfirmButton: 'Confirm',
    NoShippingPleaseContactStore: 'No couriers available. Please contact the seller.',
    SavingGold: 'Saving Gold',
    EDotationAddress: 'E-Dotation Address',
    FirstNameLastNameDoner: 'Donor Name',
    ChangeDonationInfoSuccess: 'Change Donation Info Success',
    DeleteDonationInfoSuccess: 'Delete Donation Info Success',
    changeEdonationInfo: 'Change Edonation Info',
    AddEdonationInfo: 'Add Edonation Info',
    memberDiscountCoupon: 'Discount Member Coupon'
  },
  register: {
    Register: 'Register',
    SignUp: 'Join',
    SignIn: 'Sign In',
    Username: 'Username',
    EnterUsername: 'Enter Username',
    ValidateUsername1: 'Please enter your username',
    ValidateUsername2: 'Please enter only letters and numbers',
    ValidateUsername3: 'Please enter at least 6 characters',
    Password: 'Password',
    ValidatePassword1: 'Please enter your password',
    ValidatePassword2: 'Must contain at least 1 letter and 1 number',
    ValidatePassword3: 'Must contain at least 1 letter',
    ValidatePassword4: 'Must contain at least 1 number',
    ValidatePassword5: 'Must be at least 8 characters long',
    ValidatePassword6: 'Must contain at least one uppercase letter (A–Z)',
    ValidatePassword7: '',
    TooltipPassword1: 'Must contain both letters and at least one number. Special characters are allowed.',
    TooltipPassword2: 'Must be at least 8 characters long',
    TooltipPassword3: 'Must contain at least one uppercase letter (A–Z)',
    TooltipPassword4: 'Must contain at least one lowercase letter (a–z)',
    EnterPassword: 'Enter Password',
    ConfirmPassword: 'Confirm Password',
    ValidateConfirmPassword1: 'Passwords must match',
    EnterConfirmPassword: 'Enter Confirm Password',
    Email: 'Email',
    EnterEmail: 'Enter Email',
    ValidateEmail1: 'Please enter your email',
    ValidateEmail2: 'Please enter a valid email',
    ValidateEmail3: 'Please use English letters only',
    ValidateEmail4: 'No spaces allowed',
    Phone: 'Phone Number',
    EnterPhone: 'Enter Phone Number',
    ValidatePhone1: 'Please enter your phone number',
    Accept: 'Accept',
    ServiceOneId: 'Terms Of Service Nex Gen Commerce',
    And: 'and',
    Policy: 'Privacy Policy',
    AlreadyAccount: 'Already have an account?',
    OTP: 'Request OTP',
    EnterOTP: 'Enter OTP',
    SendOTPPhone: 'An OTP has been sent to',
    WrongOTP: 'Incorrect OTP. Please try again.',
    OTPrequestAgain: 'You can request another OTP within',
    SendOTPButton: 'Send OTP',
    SendOTPButton2: 'Send OTP',
    LeavePage: 'Leave Page',
    ExitPage: 'Are you sure you want to leave the page?',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    EasyOneID: 'Confirm new account with NexGen ID',
    OneIDSuccess: 'This phone number can’t be used with another',
    OtherAccount: 'account after registration.',
    OTPCorrect: 'OTP verification successful!',
    RegisterFail1: 'This username is already in use. Please choose another username.',
    RegisterFail2: 'Missing parameter. Please check your information and try again.',
    RegisterFail3: 'This phone number is already in use.',
    AlreadyUseEmail: 'This email is already in use. Please use another email.'
  },
  Login: {
    Welcome: 'Get Started',
    WelcomeSeller: 'Login Shop',
    WelcomePurchaser: 'Login Purchaser',
    ForgotPassword: 'Forgot Password?',
    Login: 'Login',
    LoginOne: 'ONE ID Test Login',
    LoginThaID: 'Verify with ThaID',
    LoginWithThaID: 'Login ThaID',
    LoginHealthID: 'Verify with HEALTH ID',
    LoginWithHealthID: 'Login HEALTH ID',
    RegisterOTP: 'Verify with OTP',
    LoginNexGenID: 'Login With NexGen ID',
    Or: 'or',
    HaveAccount: 'Don’t have an account?',
    Register: 'Register',
    LoginFail1: 'Incorrect username or password.',
    LoginFail2: 'Username or password cannot be empty.',
    LoginFail3: 'A system error has occurred. Please contact support.',
    LoginWithPhone: 'Sign in with phone number',
    RegisterAndVerify: 'Register for <span style="color: #1B5AA3">NexGen ID</span> and verify your identity',
    OldUser: 'Sign in with an existing account',
    NewUser: 'For New Users',
    CancelBTN: 'Cancel',
    ConfirmBTN: 'Confirm'
  },
  OTPPage: {
    LoginWithOTP: 'Sign in with phone number',
    LoginWithOTP2: 'Sign in with NexGen ID',
    RegisWithOTP: 'Register with phone number',
    RegisWithOTP2: 'Register with NexGen ID',
    DescribeOTP: 'An OTP will be sent to your phone number.',
    PhoneOTP: 'Phone Number',
    TaxID: 'Tax ID',
    EnterPhone: 'Enter Phone Number',
    EnterTaxID: 'Enter Tax ID',
    ValidateOTP1: 'Please enter your phone number',
    ValidateOTP2: 'Please enter a 10-digit phone number',
    OTPNotRegister1: 'This phone number is not registered.',
    OTPNotRegister2: 'Do you want to register?',
    OTPFail: 'We’re unable to complete your request.',
    yes: 'Yes',
    no: 'No',
    OTPSend: 'An OTP has been sent to',
    ReferenceCode: 'Reference Code',
    ConfirmOTP: 'Confirm OTP',
    LoginVerifyWithOTP: 'Verify your account with an OTP',
    LogOut: 'Do you want to log out',
    YesOrNo: 'Yes or No ?',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    MobileNumberNotFound: 'Mobile number not found',
    OTPVerificationFailed: 'OTP verification failed',
    AuthorizeSuccess: 'Authorize success',
    OTPProcessFailed: 'OTP process failed',
    MobileRequired: 'The mobile no field is required',
    UsersUnauthorized: 'This user is unauthorized',
    AccountNotFound: 'Account not found',
    ThisMobileNumberUse: 'This mobile number is already in use',
    MobileAlreadyExists: 'Mobile number is already exists',
    MobileNotMatch: 'Mobile number does not match available One ID mobile',
    MobileInNGC: 'Your mobile number is',
    ManyRequests: 'Too many requests, please wait a moment',
    ManualForLogin: 'User Registration and Login Guide'
  },
  ForgotPassword: {
    PhoneType: 'Phone Number',
    headers: 'Did you forget your password?',
    describe: 'We will send you an email to reset your password.',
    send: 'Send',
    describeOTP: 'An OTP will be sent to your phone number.',
    sendOTP: 'Send OTP',
    newPassword: 'New Password',
    enterNewPassword: 'Enter New Password',
    confirmNewPassword: 'Confirm New Password',
    EnterConfirmPassword: 'Enter Confirm Password',
    resetEmailSuccess: 'An email has been sent to reset your password!',
    resetOTPSuccess: 'OTP verification successful!',
    detailReset: 'Please check your email.'
  },
  ProductPage: {
    AllReviews: 'All Reviews',
    ShippingFee: 'Shipping Fee',
    Wholesale: 'Wholesale',
    Like: 'Like',
    Share: 'Share',
    ViewShippingFee: 'View Shipping Fee',
    ShowMore: 'Show More',
    AddToCart: 'Add to Cart',
    BuyNow: 'Buy Now',
    MinOrderLimit: 'Minimum order quantity for this product is',
    Unit: 'unit(s)',
    AndUp: 'unit(s) and up',
    MaxOrderLimit: 'and the maximum order limit is',
    PerOrder: 'per order',
    ViewStore: 'View Shop',
    ProductDetails: 'Product Description',
    ProductReviews: 'Product Reviews',
    SameStoreProducts: 'From The Same Shop',
    RecommendedProducts: 'You May Also Like',
    ViewAll: 'View All Products',
    OverallRating: 'Product Ratings',
    ReviewCount: 'Reviews',
    All: 'All',
    OutOfStock: 'Out of Stock',
    InStock: 'Ready to Ship',
    PreOrder: 'Pre-order',
    ContactSupport: 'Contact Support',
    UseCoupon: 'Discount coupon',
    SpecialDiscount: 'Special Discount',
    Discount: 'Discount',
    Note: 'Note',
    TotalPreOrderItems: 'Total Pre-order Items',
    TotalItems: 'Total Items',
    PayType: 'Pay Type',
    SelectPayType: 'Select Pay Type',
    Price: 'Price',
    NoProductDetails: 'No product details available',
    Options: 'Options',
    SellerResponse: 'Seller Response',
    TimeIndicator: 'hr.', // or just leave as 'น.' if matching locale is preferred
    NoProductComments: 'No product reviews for this item yet',
    ServiceProduct: 'Service Product',
    Chat: 'Chat',
    MyLink: 'My Link',
    CopyLink: 'Copy Link',
    WholesalePrice: 'Wholesale Price',
    AndAbove: 'and up',
    ShippingCost: 'Shipping Cost',
    ShareProduct: 'Share Product',
    Sku: 'SKU Number',
    SelectATB: 'Please select product variation first',
    AddToCartComplete: 'Item has been added to your shopping cart',
    HeadTableWholeSale: {
      quantity: 'Quantity',
      PricePerPiece: 'Price per piece',
      DiscountPerPiece: 'Discount per piece'
    },
    HeadTableShipping: {
      quantity: 'Quantity',
      ShippingCost: 'Shipping cost'
    },
    TitleBundleDeal: 'Products in the Bundle Deal',
    TitleAddOnDeal: 'Add On Deal',
    ProfileTraceAbility: {
      GeneralInformation: 'General Information',
      Category: 'Category',
      ProfileName: 'Profile Name',
      ProductStory: 'Product Story Information',
      Origin: 'Origin',
      Inspiration: 'Inspiration',
      ProductionProcess: 'Production Process',
      TheBrainsBehind: 'The Brains Behind',
      Images: 'Images',
      ProductHistory: 'Product History',
      ManufacturingCountry: 'Manufacturing Country',
      DistributionSource: 'Distribution Source',
      ManufacturingDate: 'MFG/Purchase Date',
      ManufacturingLocation: 'Manufacturing Location',
      CertificationInformation: 'Standards and Certification Information',
      Certificate: 'Certificate',
      Type: 'Type',
      CertificateNo: 'Certificate No.',
      CertificationStartDate: 'Certification Start Date',
      CertificationExpiryDate: 'Certification Expiry Date',
      CertificateImage: 'Standard Image',
      ProductStatus: 'Product Status',
      ViewDetails: 'Click to View Details',
      NoData: 'No'
    },
    ViewDetailProduct: 'View Product Details',
    AttachedProductPicture: 'Attached Product Picture',
    UploadProductImages: 'Upload Product Images',
    PriceClearly: 'It is essential to see the price of the product clearly.',
    SupportsFile: '(Supports file extensions jpg, png, heic)',
    DealPriceOffer: 'Deal Price Offer',
    SpecifyPriceOffer: 'Specify your price offer.',
    RequestSented: 'A price request has been sent to the store.',
    TheStoreWillReviewYourRequest: 'The store will review your request.',
    inTwodays: 'It will take 1-2 business days to respond.',
    checkDetails: 'You can check the details in the ‘My Direct Deals’ menu.',
    confirm: 'Confirm',
    cancel: 'Cancel',
    GoToCart: 'Go to shopping cart',
    AddToCartBundle: 'Add to cart',
    ProductFeature: 'Product Feature',
    NoProductFeature: 'This product has no product feature',
    DiscountPrice: 'Discount Price',
    OnlyOneOption: 'Choose only one option',
    DiscountTypeBaht: 'Discount in baht',
    DiscountTypePercent: 'Discount in percentage',
    Specify: 'Specify',
    TitleFDA: 'FDA Number / FDA Registration Number',
    CertificateNumber: 'Certificate Number',
    CertificateExpiryDate: 'Certificate Expiry Date',
    ProductExpiryDate: 'Product Expiry Date'
  },
  ShopPage: {
    Shop: 'Shop',
    PendingApproval: 'Waiting for Approval',
    StoreRating: 'Shop Rating',
    NoRatingYet: 'No rating yet',
    AllProductsList: 'All Product Listings',
    AllProducts: 'All Products',
    RecommendedPromotion: 'Recommended',
    // RecommendedPromotion: 'Recommended promotions',
    NewArrival: 'New Products',
    DiscountedProducts: 'Discounted',
    // DiscountedProducts: 'Discounted Products',
    BestSellers: 'Best-Selling',
    // BestSellers: 'Best-Selling Products',
    Recommended: 'Recommended Products',
    GeneralProducts: 'General Products',
    OutOfStock: 'Out of Stock',
    All: 'All',
    SameStoreProducts: 'Products from the same shop',
    AboutStore: 'About the Shop',
    RegisteredOnly: 'Products for Registered Partners Only',
    RejectRegisteredOnly: 'The seller has rejected your request',
    RegisterAsPartner: 'Register as a Partner',
    StoreNotFound: 'Shop Not Found',
    PleaseCheckStore: 'Please recheck the shop you are looking for',
    ContactStore: 'Please contact the shop',
    NoProductYet: 'This shop has no products yet',
    RequestSubmitted: 'Your request has been submitted. Please wait for shop approval.',
    ExternalOrder: 'External Purchase',
    OrContactSupport1: 'or contact support',
    ClickIfInterested: 'If you are interested, click here',
    CustomerCode: 'Customer Code',
    SelectCustomerInfo: 'Select Customer Info',
    InternalOrder: 'Internal Purchase',
    StoreCoupon: 'Shop Discount Code',
    ViewAll: 'View All',
    CouponConditions: 'Coupon Usage Conditions',
    NoExpiry: 'No Expiration Date',
    Used: 'Used',
    Coupon: 'Coupon',
    Discount: 'Discount',
    Freebie: 'Free Gift',
    SaveCode: 'Save Code',
    SavedCode: 'Code Saved',
    Minimum: 'Minimum',
    THB: 'THB',
    FreeShippingCode: 'Free Shipping Code',
    AllProductsCategory: 'All Products / All Categories',
    ShopMember: 'Shop Member',
    Title: 'Home Page',
    Category: 'Category',
    Type: 'Type',
    Price: 'Price',
    NoProduct: 'No Product Yet',
    SortBy: 'Sort By',
    Filter: 'Filter',
    Article: 'Article',
    ReadMore: 'Read More',
    NoArticles: 'No Articles in Shop',
    CustomerTypeList: 'Customer Types List',
    Company: 'Company',
    CompanyOrder: 'Orders for Company Organizations',
    Individual: 'Individual',
    PersonalOrder: 'Orders for Individuals',
    AllCoupons: 'All Coupons',
    ValidUntil: 'Valid Until',
    DiscountCodeConditions: 'Discount Code Conditions',
    PromotionType: 'Promotion Type',
    ProductDiscount: 'Product Discount',
    ShippingDiscount: 'Shipping Discount',
    CouponEligibility: 'Coupon Eligibility',
    Unlimited: 'Unlimited',
    DiscountCodeDetails: 'Discount Code Details',
    FreebieDetails: 'Free Gift Details',
    OrderList: 'Order List',
    ProductName: 'Product Name',
    Options: 'Options',
    Quantity: 'Quantity',
    FreeGift: 'Free Gift',
    CustomerList: 'Customer List',
    AddCustomerInfo: 'Add Customer Info',
    FindNamePartner: 'Find Name Partner',
    AddInfo: 'Add Info',
    SelectAddress: 'Select Shipping Address',
    AllAddresses: 'All Addresses',
    ItemList: 'Item List',
    AddNewAddress: 'Add New Address',
    PartnerRequest: 'Request to Become Partner',
    StoreName: 'Shop Name',
    PartnerRequestDetails: 'Partner Request Details',
    Email: 'E-mail',
    EmailNote: '*Used for notifications to partners',
    EmailNote2: 'Used for sale notifications',
    CustomerGroup: 'Customer Group',
    SpecifyGroup: 'Specify Customer Group',
    RequiredDocuments: 'Documents to Upload',
    UploadNote: '(Supports .pdf files up to 5 MB)',
    UploadFile: 'Upload File',
    DropFileHere: 'Drop your file here',
    OrChooseFile: 'Or choose from your computer',
    FileNote: '(.PDF files up to 5 MB)',
    Cancel: 'Cancel',
    SubmitRequest: 'Submit Request',
    CreateQuotation: 'Create Quotation',
    Budget: 'Budget',
    DeductBudget: 'Deduct Budget',
    Confirm: 'Confirm',
    DocumentSample: 'Sample Document',
    MustRegisterToView: 'You must register as a partner with the seller to view products and services',
    OrContactSupport: 'Or contact support',
    ConfirmPartnerRequest: 'Do you want to request to be a partner with this Shop?',
    PartnerRequestSent: 'Partner Request Submitted',
    AlreadyRequested: 'You have already submitted a partner request',
    Clear: 'Clear',
    ConfirmAction: 'Confirm',
    RegisterMemberBenefit: 'Register now and enjoy exclusive benefits',
    MemberBenefits: 'Discounts • Free shipping • Reward points',
    RegisterNow: 'Register now',
    RegistrationSuccess: 'Membership registration successful',
    RegisterMember: 'Register as a member',
    ManyExclusiveBenefits: 'Enjoy many exclusive benefits',
    FreeMembershipBenefits: 'Join for free! Earn reward points and exclusive member benefits',
    JoinShopBenefits: 'Join Shop Benefits',
    Benefits: 'Benefits',
    RegistrationBonusPoints: 'Registration Bonus Points',
    EarnPointsOnEveryOrder: 'Earn points on every order',
    MemberInformation: 'Member Information',
    Name: 'Name',
    EmailShop: 'Email',
    PhoneNumber: 'Phone Number',
    DateOfBirth: 'Date of Birth',
    Gender: 'Gender',
    SetDateOfBirth: 'Set Date of Birth',
    SelectGender: 'Select Gender',
    Accept: 'Accept',
    Close: 'Close',
    CannotLoadUserData: 'Unable to load user data',
    ShopOrUserDataNotFound: 'Shop or user data not found',
    RegistrationFailed: 'Membership registration failed',
    SomethingWentWrong: 'Something went wrong. Please try again.',
    OnlyMore: 'Only',
    ToReachNextLevel: 'to reach',
    HighestLevel: 'You are at the highest level',
    Highest: 'Highest',
    Points: 'Points',
    Expired: 'Expired',
    Within: 'Within',
    Days: 'days',
    NoPoints: 'No points',
    TotalPoints: 'Total Points',
    ComingToAccountSoon: 'Coming to your account soon',
    ExpiringSoon: 'Expiring soon',
    RedeemPoints: 'Redeem Points',
    Earned: 'Earned',
    ExpiredPoints: 'Expired',
    Date: 'Date',
    OrderNumber: 'Order Number',
    PointsUsedDate: 'Points Used Date',
    ExpirationDate: 'Expiration Date',
    DetailDescription: 'Details',
    AllLevels: 'All Levels',
    BackToMemberPage: 'Back to Member Page',
    Level: 'Level'
  },
  AllShopsPage: {
    Home: 'Home Page',
    AllShops: 'All Shops',
    AllShop: 'All Shop',
    Shop: 'Shop',
    SearchResults: 'Search Results',
    SearchShops: 'Search by shop name',
    NoShop: 'No shop available',
    ShopNotFound: 'Shop not found',
    ShopSearchEmpty: 'No shop matched your search. Please check again.'
  },
  YourOrderPage: {
    banner: require('@/assets/new_yourorder_en.png'),
    bannerMobile: require('@/assets/yourordermobile_en.png'),
    PaymentInformation: 'Payment Information',
    OrderID: 'Order ID',
    TotalAmount: 'Total Amount',
    NexgenDiscountCoupon: 'Nexgen Discount Coupon',
    SellerDiscount: 'Seller Discount',
    NexgenPoinsDiscount: 'Nexgen Points Discount',
    SystemCoupon: 'System Coupon (Free Shipping)',
    StoreCoupon: 'Store Coupon (Free Shipping)',
    DateTimeofPayment: 'Date & Time of Payment',
    PaymentMethod: 'Payment Method',
    PaymentResult: 'Payment Result',
    OrderDetails: 'Order Details',
    Store: 'Store',
    ProductDetails: 'Product Details',
    UnitPrice: 'Unit Price',
    Quantity: 'Quantity',
    TotalPrice: 'Total Price',
    ShippingAddress: 'Shipping Address',
    InvoiceAddress: 'Tax Invoice Address',
    PickupDate: 'Pickup Date',
    PickupTime: 'Pickup Time',
    ShippingNew: require('@/assets/shipping_new_en.png'),
    PickUpNew: require('@/assets/pickup_new_en.png'),
    Baht: 'baht',
    PaymentConfirmed: 'Payment Confirmed',
    COD: 'Cash on Delivery (COD)',
    Freegift: 'Free Gift',
    DiscountCode: 'Discount Code',
    ListOf: 'List of',
    employees: 'employees',
    Department: 'Department',
    Company: 'Company',
    SubDistrict: 'Sub-district',
    District: 'District',
    Province: 'Province',
    Time: 'AM/PM',
    GeneralProducts: 'General Products',
    ServiceProduct: 'Service Product',
    GotoOrderList: 'Go to Order List',
    GotoHomepage: 'Go to Homepage',
    Paymentincomplete: 'Payment Incomplete',
    NoAddress: 'You haven’t added your address yet.',
    Incompleteinformation: 'Incomplete information.',
    ConfirmOrder: 'Please confirm your order again.',
    OverWeight: 'The total weight of your items exceeds 50 kilograms. To proceed with your order, please contact our staff. Thank you.',
    Sku: 'This SKU',
    WeightProblem: 'has an issue with the weight. Please contact our staff.',
    UserPermission: 'Your permissions have changed. Please refresh or check your access.',
    BundleDealDiscount: 'Bundle Deal Discount'
  },
  ListCoupon: {
    // View Terms of Use
    Terms: 'View Terms of Use',
    // Discount Terms
    DiscountTerms: 'Discount Terms',
    // Detail Coupon
    DetailCoupon: 'Detail Coupon',
    // Order List
    OrderList: 'Order List',
    // Product Name
    ProductName: 'Product Name:',
    // Options
    Options: 'Options:',
    // Quantity
    Quantity: 'Quantity:',
    // Free gift
    FreeGift: 'Free gift',
    // Discount
    Discount: 'Discount',
    // Shipping Discount
    ShippingDiscount2: 'Shipping Discount',
    // Baht
    Baht: 'Baht',
    // Minimum
    Minimum: 'Minimum',
    // Promotion Type
    PromotionType: 'Promotion Type',
    // Coupon Usage Rights
    CouponUsageRights: 'Coupon Usage Rights',
    // vouchers
    Vouchers: 'vouchers',
    // Maximum Discount
    MaximumDiscount: 'Maximum Discount',
    // Up to
    UpTo: 'Up to',
    // Off
    Off: 'Off',
    // No limit
    NoLimit: 'No limit',
    // Participating Stores
    ParticipatingStores: 'Participating Stores',
    // There are
    ThereAre: 'There are',
    // participating stores.
    participatingstores: 'participating stores.',
    // Show less
    ShowLess: 'Show less',
    // See more
    SeeMore: 'See more',
    // Valid at all stores
    ValidAtAllStores: 'Valid at all stores',
    Header: 'Discount Coupon',
    HeaderSystemCode: 'Nexgen Discount Coupon',
    HeaderSystemCodeShipping: 'Nexgen Shipping Coupon',
    PlaceHolder: 'Search Coupon Discount',
    GeneralDiscount: 'General Discount',
    BudgetDiscount: 'Budget Discount',
    ShippingDiscount: 'Shipping Discount',
    Min: 'Min',
    Max: 'Max',
    Validfrom: 'Valid from',
    Onwards: 'onwards',
    SelectCoupon: 'Select Coupon',
    FreeGiftCoupon: 'Free Gift Coupon',
    ShowMoreCoupons: 'Show More Coupons',
    ForStore: 'For',
    Only: 'Only',
    NoCoupon: 'No Store Discount Coupon Available',
    NoCouponSystem: 'No Nexgen Discount Coupon Available',
    CouponNotFound: 'Coupon not found or not currently valid',
    PointError: 'Point system error. Please try again later',
    PleaseSelect: 'Please select a discount first.',
    NotExceed1: 'The amount of discount points you can use',
    NotExceed2: 'cannot exceed 25% of the total price.',
    CannotUse: 'This coupon cannot be used because the usage conditions are not met',
    errorMessage1: 'Coupon not found',
    errorMessage2: 'Coupon not currently valid',
    errorMessage3: 'Data has been changed.',
    errorMessage4: 'Please Do you want to save or discard the changes?',
    errorMessage5: 'Please check the discount code again. The entered details do not meet the code’s conditions.',
    errorMessage6: 'The product price does not meet the minimum requirement.',
    errorMessage7: 'This discount cannot be used for in-store pickup.',
    errorMessage8: 'Coupon collected successfully.',
    errorMessage9: 'Unable to collect coupon.',
    errorMessage10: 'Code not found',
    errorMessage11: 'The code',
    errorMessage12: 'already exists. Please check again.',
    errorMessage13: 'Please check the information again.',
    Balance: 'Balance',
    Save: 'Save',
    budgetRemaining: 'Budget Remaining',
    budgetType: 'Budget',
    memberOnly: 'Member Only'
  },
  AllProductCategory: {
    HomePage: 'Home Page',
    Categories: 'Product Categories'
  },
  SearchPage: {
    HomePage: 'Home Page',
    RelatedShops: 'Shops related to',
    All: 'All',
    Shop: 'Shop',
    OtherShops: 'Other Shops',
    ViewShop: 'View Shop',
    SearchKeyword: 'Search keyword:',
    NoResults: 'No search results found',
    CheckSpelling: 'Please check if the spelling is correct',
    TrySimilarWords: 'Or try using similar words',
    TryAgain: 'Please try searching again',
    SearchResults: 'Search Results',
    list: 'list',
    Store: 'Shop',
    Group: 'Group Shop'
  },
  SelectPrice: {
    Price: 'Price',
    All: 'All',
    Low: 'Price: Low to High',
    High: 'Price: High to Low',
    Higher: 'High to Low',
    Lower: 'Low to High',
    AllCategories: 'All Categories',
    NotFoundTag: 'No products found in the product tag you selected.',
    NotTag: 'There are no product tags listed.',
    TagProduct: 'Tag Product'
  },
  BankAccountPage: {
    header: 'Bank Account',
    headerModal: 'My Account',
    index: 'Account No. ',
    addAccount: 'Add Account',
    editAccount: 'Edit',
    editAccountModal: 'Edit Account',
    deleteAccount: 'Delete',
    overTenAccount: 'Cannot add more than 10 accounts',
    accountName: 'Name',
    accountNameModal: 'Account Name',
    PlaceHolderAccountName: 'Enter account name',
    validateAccountName1: 'Please enter account name',
    validateAccountName2: 'Only letters can be enter',
    bankName: 'Bank',
    bankNameModal: 'Bank Name',
    PlaceHolderBankName: 'Enter bank name',
    validateBankName1: 'Please select bank name',
    accountNumber: 'Number',
    accountNumberModal: 'Account Number',
    PlaceHolderAccountNumber: 'Enter account number',
    validateAccountNumber1: 'Please enter account number',
    validateAccountNumber2: 'Account number must be more than 9 digits',
    branch: 'Branch',
    branchModal: 'Branch Name',
    PlaceHolderBranch: 'Enter branch name',
    validateBranch1: 'Please enter branch name',
    accountDefault: 'Set as default account',
    addAwait: 'Add',
    editAwait: 'Edit',
    deleteAwait: 'Delete',
    MyAccount: ' my account',
    Proceed: 'Do you want to proceed with this action?',
    Review: 'Have you reviewed the information?',
    Success: ' successful',
    DetailSuccess1: 'You have successfully ',
    DetailSuccess2: ' your account',
    NoFound: 'No account found.',
    Press: 'You can press '
  },
  FavoritePage: {
    header: 'Favorite items',
    PlaceHolderName: 'Search for products',
    PleceHolderCategory: 'Search for categories',
    Type: 'Type',
    Category: 'Category',
    Wishlist: 'Your wishlist contains',
    list: 'items',
    TypeList: {
      All: 'All',
      GeneralProducts: 'General Products',
      ServiceProduct: 'Service Product'
    },
    NoProduct1: 'No favorite items yet. ',
    NoProduct2: 'You can tap ',
    NoProduct3: 'Shop Now'
  },
  FollowedShopPage: {
    header: 'Follow shop',
    PlaceHolderName: 'Search for Follow shop',
    // PleceHolderCategory: 'เลือก',
    Type: 'Shop',
    Category: 'Shop',
    Wishlist: 'Fan Club',
    Follow: 'Follow'
    // list: 'รายการ',
    // TypeList: {
    //   All: 'ทั้งหมด',
    //   GeneralProducts: 'สินค้าทั่วไป',
    //   ServiceProduct: 'สินค้าบริการ'
    // },
    // NoProduct1: 'ไม่มีรายการสินค้าที่ถูกใจ',
    // NoProduct2: 'สามารถกด',
    // NoProduct3: 'ซื้อสินค้า'
  },
  CouponProfile: {
    header: 'My Coupons and Points',
    Condition: 'Point conditions are subject to the store’s terms.',
    headerTable: 'Reward points from purchases at participating stores',
    subHeaderTable: {
      Shop: 'Shop Name',
      getPoint: 'Point-to-order ratio',
      usePoint: 'Points Used',
      detailTable: 'Detail',
      detail: {
        OrderList: 'Order List',
        ProductPrice: 'Product Price',
        PointsEarned: 'Points Earned',
        PointsUsed: 'Points Used',
        total: 'Total',
        ViewDetails: 'View Details'
      },
      Baht: 'Baht',
      Per: 'Per',
      Point: 'Point',
      NumberOfRows: 'Number of Rows'
    },
    Coupon: {
      CanUse: 'Valid code',
      CannotUse: 'Invalid/Expired',
      CouponCard: {
        CannotUseWith: 'Not combinable',
        Minimum: 'Minimum spend',
        Maximum: 'Maximum discount',
        ValidUntil: 'Valid until',
        NoExpirationDate: 'No expiration date',
        Used: 'Used',
        Remaining: 'Remaining',
        ViewConditions: 'Conditions',
        Coupons: 'Coupon',
        Discount: 'Discount',
        FreeGift: 'Bonus'
      }
    },
    ConditionModal: {
      header: 'Coupon Usage Conditions',
      PromotionType: 'Promotion Type',
      PromotionTypeList: {
        ProductPriceDiscount: 'Product Price Discount',
        ShippingDiscount: 'Shipping Discount',
        FreeGiftCoupon: 'Free Gift Coupon'
      },
      CouponEligibilityList: {
        CouponEligibility: 'Coupon Eligibility',
        CanBeUsed: 'Can be used',
        Times: 'times'
      },
      AvailableCreditLimit: 'Available Credit Limit',
      MaximumDiscount: 'Maximum Discount',
      Unlimited: 'Unlimited',
      ParticipatingStores: 'Participating Stores',
      ListOfAll: 'List of all',
      Stores: 'stores',
      ValidAtAllStores: 'Valid at all stores',
      ShowLess: 'Show Less',
      ShowMore: 'Show More',
      DiscountCodeDetails: 'Discount Code Details',
      FreeGiftDetails: 'Free Gift Details',
      OrderList: 'Order List',
      ProductName: 'Product Name',
      Attribute: 'Attribute',
      Amount: 'Amount',
      FreeGift: 'Free Gift',
      GoBack: 'Go Back',
      NoCouponsAvailable: 'No coupons available'
    }
  },
  AddressProfilePage: {
    headerPage: 'Shipping Address',
    headerInvoice: 'Tax Invoice Address',
    AddAddressBtn: 'Add Address',
    OverAddress: 'Cannot add more than 10 addresses',
    OverAddressInvoice: 'Cannot add more than 5 addresses',
    SetDefaultAddress: 'Set as default address',
    SuccessSetDefaultAddress: 'Set as default address successfully',
    FailedSetDefaultAddress: 'Failed to set as default address',
    Individual: 'Individual',
    LegalEntity: 'Legal Entity',
    remark: 'Remark',
    // remark: 'Remark (TH)',
    remarkEn: 'Remark (EN)',
    BranchNo: 'Branch No.',
    TaxID: 'Tax ID',
    NotHaveAddress: 'You don’t have any address yet',
    Click: 'You can click ',
    ShippingPurpose: ' For shipping purposes',
    TaxInvoicePurpose: ' For tax invoice purposes',
    ShippingAddressModal: {
      AddressTH: 'Thailand Address',
      AddressInter: 'Foreign Address',
      TitleAddAddress: 'Add Shipping Address',
      TitleEditAddress: 'Edit Shipping Address',
      RecipientInformation: 'Recipient Information',
      RecipientAddressInformation: 'Recipient Address Information',
      CompanyName: 'Company Name',
      FirstName: 'First Name',
      // FirstName: 'First Name (TH)',
      PlaceHolderFirstName: 'Enter first name',
      // PlaceHolderFirstName: 'Enter first name (TH)',
      LastName: 'Last Name',
      // LastName: 'Last Name (TH)',
      PlaceHolderLastName: 'Enter last name',
      // PlaceHolderLastName: 'Enter last name (TH)',
      FirstNameEn: 'First Name (EN)',
      PlaceHolderFirstNameEn: 'Enter first name (EN)',
      LastNameEn: 'Last Name (EN)',
      PlaceHolderLastNameEn: 'Enter last name (EN)',
      Phone: 'Phone',
      PlaceHolderPhone: 'Enter phone number',
      Email: 'Email',
      PlaceHolderEmail: 'Enter email',
      HouseNo: 'House No.',
      PlaceHolderHouseNo: 'Enter house number',
      RoomNo: 'Room No.',
      PlaceHolderRoomNo: 'Enter room number',
      Floor: 'Floor',
      PlaceHolderFloor: 'Enter floor',
      BuildingName: 'Building Name',
      // BuildingName: 'Building Name (TH)',
      BuildingNameEn: 'Building Name (EN)',
      PlaceHolderBuildingName: 'Building,Apartment,Condominium Name',
      Village: 'Village',
      // Village: 'Village (TH)',
      VillageEn: 'Village (EN)',
      PlaceHolderVillage: 'village name',
      VillageNo: 'Village No.',
      PlaceHolderVillageNo: 'Enter village number',
      Alley: 'Alley',
      // Alley: 'Alley (TH)',
      AlleyEn: 'Alley (EN)',
      PlaceHolderAlley: 'Enter alley',
      Junction: 'Junction',
      // Junction: 'Junction (TH)',
      JunctionEn: 'Junction (EN)',
      PlaceHolderJunction: 'Enter junction',
      Road: 'Road',
      // Road: 'Road (TH)',
      RoadEn: 'Road (EN)',
      PlaceHolderRoad: 'Road Name',
      SubDistrict: 'Sub-district',
      PlaceHolderSubDistrict: 'Enter Sub-district',
      District: 'District',
      PlaceHolderDistrict: 'Enter District',
      Province: 'Province',
      PlaceHolderProvince: 'Enter Province',
      Zipcode: 'Zip Code',
      PlaceHolderZipCode: 'Enter Zip Code',
      PlaceHolderRemark: 'Enter remark',
      error1: 'Invalid information',
      error2: 'Please enter recipient\'s first name',
      error3: 'Maximum 20 characters',
      error4: 'Please enter recipient\'s last name',
      error5: 'Maximum 30 characters',
      error6: 'Please enter phone number',
      error7: 'Phone number should start with 0',
      error8: 'Phone number must be more than 9 digits',
      error9: 'Please enter email address',
      error10: 'Please enter a valid email address',
      error11: 'Thai characters are not allowed',
      error12: 'Special characters are not allowed',
      error13: 'Email must not contain spaces',
      error14: 'Please specify house number',
      error15: 'Please enter correct information',
      error16: 'Incorrect information provided',
      error17: 'Numbers only',
      error18: 'Maximum 120 characters',
      error19: 'Invalid input',
      error20: 'Invalid input. Please check your information and try again.',
      error21: 'Please select sub-district, district, province, and postal code.',
      error22: '(Sub-district, District, Province, Postal Code)',
      error23: 'Please enter more than 9 digits',
      error24: 'Please enter company name',
      error25: 'Maximum 100 characters',
      error26: 'Please enter first name',
      awaitSuccess1: 'Adding address',
      awaitSuccess2: 'Editing address',
      Success1: 'Address added successfully',
      Success2: 'Address edited successfully',
      Success3: 'You have successfully added an address',
      Success4: 'You have successfully edited an address'
    },
    TaxInvoiceAddressModal: {
      TitleAddAddressInvoice: 'Add Tax Invoice Address',
      TitleEditAddressInvoice: 'Edit Tax Invoice Address',
      GeneralInformation: 'General Information',
      TaxInvoiceInformation: 'Tax Invoice Information',
      SameAddress: 'Use shipping address',
      PlaceholderTaxInvoiceName: 'Name for Tax Invoice',
      TaxInvoiceName: 'Name for Tax Invoice (TH)',
      TaxInvoiceNameEn: 'Name for Tax Invoice (EN)',
      BranchNo: 'Branch No.',
      enterCode: '(Please enter code 00000 if this is the head office)',
      TaxInvoiceNo: 'Tax Identification Number',
      TaxInvoiceEmail: 'Taxpayer Email',
      PlaceholderTaxInvoiceAddress: 'Billing Address for Tax Invoice',
      TaxInvoiceAddress: 'Billing Address for Tax Invoice (TH)',
      TaxInvoiceAddressEn: 'Billing Address for Tax Invoice (EN)',
      error2: 'Please select information',
      error3: 'Please enter the name for the tax invoice',
      error4: 'Tax invoice name must not exceed 100 characters',
      error5: "Please enter the recipient's Tax ID",
      error6: 'Tax ID must be 13 digits',
      error7: 'Invalid Tax ID',
      error8: 'Please specify the address',
      error9: 'Please enter email address',
      error10: 'Please enter a valid email address',
      error11: 'Taxpayer email must not exceed 256 characters',
      error12: 'Please enter phone number',
      error13: 'Phone number should start with 0',
      error14: 'Phone number must be 10 digits',
      error15: 'Please enter branch No.',
      error16: 'Branch No. must be 5 digits',
      error17: 'Please select',
      error18: 'No shipping address available',
      error19: 'Please set a default shipping address first',
      error20: 'Please check your information and try again.',
      error21: 'Please enter all required information.',
      error22: 'Please check the information again',
      error23: 'Please select (Individual or Legal Entity)',
      error24: 'This customer Id is already in use',
      error25: 'An error occurred. Please try again later.',
      Success1: 'Address added successfully',
      Success2: 'Address edited successfully',
      Success3: 'You have successfully added an address',
      Success4: 'You have successfully edited an address'
    },
    deleteAddress: {
      TitleShippingAddress: 'Delete Shipping Address',
      TitleTaxInvoiceAddress: 'Delete Tax Invoice Address',
      DeleteShippingAddressSuccess: 'Delete Shipping Address Successfully',
      DeleteShippingAddressSuccess1: 'You have successfully deleted the shipping address',
      DeleteTaxInvoiceAddressSuccess: 'Delete Address Successfully',
      DeleteTaxInvoiceAddressSuccess1: 'You have successfully deleted the tax invoice address'
    }
  },
  ListPoint: {
    StoreDiscountPoint: 'Store Discount Points',
    Points: 'points',
    RedeemPoints: 'Use Points',
    PointUsageRules: 'Terms of Point Use',
    MaximumUsablePoints: 'maximum usable points',
    Baht: 'baht',
    Spend: 'spend',
    Earn: 'earn',
    PointUsageMustNotExceed: 'point usage must not exceed',
    OrderTotal: 'of the order total',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    NoDocument: 'no document',
    CompanyCertificateCopy: 'company certificate copy',
    CompanyCertificateCopyDocument: 'company certificate copy document',
    PointError: 'Point error. Please try again later.',
    SystemError: 'System error. Please contact support.',
    PleaseSelectDiscount: 'Please select a discount first.',
    PointExceedLimit: 'Points can be used for up to 25% of the order total'
  },
  ListCode: {
    Title: 'Partnership Coupon',
    SearchPlaceholder: 'Search Coupon Discount',
    EmployeeList: 'Employee List',
    ListName: 'Person',
    Department: 'Career Field',
    Company: 'Company',
    EmployeeName: 'Employee name',
    NotAdded: 'No code has been added',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Delete: 'Delete',
    TitleConfirm: 'Changes Detected',
    Description: 'Would you like to save or discard the changes?',
    Save: 'Save',
    InvalidCouponCondition: 'Please verify the coupon details again. The conditions do not match.',
    NotFound: 'Coupon code not found',
    AlreadyUsed_Prefix: 'Coupon code',
    AlreadyUsed_Suffix: 'has already been used. Please check again.',
    InvalidInput: 'Please check the input again',
    PointError: 'Points error, please try again later',
    SystemError: 'System error, please contact support'
  },
  withdrawAffiliate: {
    WithdrawHistory: 'Withdrawal History',
    ConfirmTitle: 'Do you want to withdraw the money?',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    TopEarning: 'Top Earning',
    TopProduct: 'Top Product',
    SearchPlaceholder: 'Search',
    NoData: 'No records found',
    Views: 'Views',
    Orders: 'Orders',
    TotalSales: 'Total Sales',
    Commission: 'Commission',
    Times: 'times',
    Items: 'items',
    Baht: 'baht',
    Withdraw: 'Withdraw',
    FeeOnly: '5 Baht fee',
    MinWithdrawNote: 'Minimum 20 Baht',
    EKYCWarning: 'You must complete eKYC verification before you can withdraw.',
    EKYCWarning1: 'You must complete eKYC verification',
    EKYCWarning2: 'before you can withdraw.',
    OrderNumber: 'Order Number',
    Shop: 'Shop',
    OrderAffiliate: 'Order Affiliate',
    TotalAffiliate: 'Total Affiliate (Baht)',
    TimeTransfer: 'Time Transfer',
    TransferAffiliate: 'Transfer Status',
    SystemError: 'System error, please contact support',
    NoWithdrawData: 'No Affiliate withdrawal data available'
  },
  clickAffiliateBuyer: {
    Title: 'Click Report',
    ClickTime: 'Click Time',
    ClickTimePlaceholder: 'Search by click time',
    ClickCode: 'Click Code',
    ClickCodePlaceholder: 'Search by click code',
    Region: 'Region',
    RegionPlaceholder: 'Search by region',
    SubId: 'Sub_id',
    SubIdPlaceholder: 'Search by sub_id',
    Clear: 'Clear',
    TotalResult: 'Total',
    Items: 'items',
    Export: 'Export',
    NoClickData: 'No click report found',
    EmptyMessage: 'You have no click reports',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Reference: 'Reference'
  },
  ReviewListBuyer: {
    title: 'Review',
    notEvaluation: 'Not yet evaluated',
    assessed: 'Evaluated',
    searchOrder: 'Search by order ID',
    orderNot: 'List of all orders not yet evaluated',
    orderSuccess: 'List of all orders evaluated',
    order: 'order',
    orderNotFound: 'No satisfaction evaluation data found',
    noResultsText: 'No customer satisfaction data found for the searched product',
    noDataText: 'No customer satisfaction data is available in the table',
    numberRows: 'Number of rows',
    status1: 'satisfaction already evaluated',
    status2: 'waiting for your feedback',
    btnDetail: 'Detail',
    btnReview: 'Give Evaluation',
    noOrderEvaluated: "You don't have any satisfaction evaluations yet",
    thOrder: 'order number',
    thStatus: 'status',
    thExpired: 'expired review',
    thManage: 'manage',
    textDialog: 'Please evaluate your satisfaction with the product',
    titleSKU: 'SKU',
    titleEdit: 'Edit',
    titleReviewEdit: 'Write your satisfaction evaluation',
    titleDateEdit: 'Satisfaction evaluation date',
    titleDateSuccess: 'Edit satisfaction evaluation date',
    titleReviewSuccess: 'Review',
    noImage: 'No Image',
    uploadImage: 'Upload your image here',
    fixedSizeImage: '(upload up to 6 images max size 6 MB each, file types: .png, .jpeg, .jpg)',
    uploadVideo: 'Upload your video here',
    fixedSizeVideo: '(upload up to 1 video max size 20 MB each, file types: .mp4)',
    anonymous: 'Anonymous',
    btnCancel: 'Cancel',
    btnSuccess: 'Save'
  },
  Affiliate: {
    AffiliateShop: 'Affiliate Shops',
    AffiliateShopDescription: 'Shops participating in the Affiliate',
    SearchShop: 'Search Shop Name',
    AllShops: 'All',
    JoinAffiliate: 'Join Affiliate',
    WaitingForApproval: 'Waiting for approval',
    NotJoined: 'Not joined the Affiliate',
    CancelRequest: 'Cancel',
    List: 'List',
    NoShopFound: 'No shop found',
    NoAffiliateShop: 'No Affiliate shops available',
    UpTo: 'Up to',
    NotSpecified: 'Not specified',
    StartDate: 'Start date',
    EndDate: 'End date',
    Unlimited: 'Unlimited',
    ViewProducts: 'View products',
    NoItems: 'No items yet',
    NotJoinedAffiliate: 'Not Joined the Affiliate',
    JoinAllAffiliateShops: 'Join all Affiliate shops',
    ConfirmShopNameBeforeJoining: 'Please verify the shop name before confirming to join the Affiliate',
    Confirm: 'Confirm',
    CancelSelection: 'Cancel selection',
    ConfirmShopNameBeforeCancelAll: 'Please verify the shop name before cancelling all Affiliate participation',
    AllShopsAffiliate: 'All Affiliate Shops',
    JoinAll: 'Join All Affiliates',
    WaitingAll: 'All Pending Approvals',
    RejectAll: 'Not joined all Affiliates',
    DataTable: {
      RowCount: 'Number of rows',
      ShopName: 'Shop Name',
      OfferDuration: 'Offer Duration',
      CommissionRate: 'Commission Rate',
      Status: 'Status',
      Note: 'Note',
      Action: 'Action'
    },
    WaitingApproval: 'Waiting for shop approval',
    JoinSuccess: 'Successfully joined Affiliate',
    ProductList: 'Product List',
    Shop: 'Shop',
    SearchProductName: 'Search product name',
    AllAffiliateProducts: 'All Affiliate products',
    NoAffiliateProductFound: 'No Affiliate products found',
    SelectAllOnPage: 'Select all products on this page',
    Select: 'Select',
    GetAllLinks: 'Get all links at once',
    ValidateSelectionBeforeGetLink: 'Please verify your selected Affiliate products before getting all links at once',
    ConfirmCancelAllSelection: 'Confirm cancel all selections',
    ConfirmCancelAllMessage: 'Are you sure you want to cancel the selection of all products',
    MyShop: {
      Followers: 'Fan Club',
      MaximumCommissionRate: 'Maximum Commission Rate',
      Popular: 'Popular',
      Commission: 'Commission',
      Price: 'Price',
      NoProductsFound: 'No products found',
      Share: 'Share'
    },
    Product: {
      bath: 'baht',
      Approximately: 'Approximately',
      JoinAffiliate: 'Join NexGen Affiliate to earn income.',
      Share: 'Share',
      Or: 'or',
      Product: 'Product',
      Promote: 'Promote',
      Link: 'Link',
      ViewShop: 'View Shop',
      ShareLinkAff: 'Share the link to earn money.',
      ShareLink: 'Share Link',
      DownloadImg: 'Download all images',
      FDAApproved: 'FDA Certified',
      Sold: 'Sold',
      K: 'K',
      Unit: 'pcs',
      ContactSupport: 'Contact Support',
      CommissionRate: 'Commission Rate',
      GetLink: 'Get Link',
      ProductOfferLink: 'Product Offer Link',
      PleaseCopyShortLink: 'Please copy the short link',
      CopyLink: 'Copy Link',
      Close: 'Close',
      CopySuccess: 'Link copied successfully',
      CopySuccessDescription: 'You can now share the link to earn income.',
      CopyError: 'An error occurred. Unable to get the link',
      MultipleProductLinks: 'Multiple Product Links.xlsx'
    },
    ProductListTitle: 'Affiliate Products',
    SystemError: 'A system error occurred. Please contact support.'
  },
  PaymentSettings: {
    Title: 'Payment Settings',
    AccountType: 'Account Type',
    PaymentInfo: 'Payment Information',
    AccountName: 'Account Name',
    BankName: 'Bank Name',
    BankBranch: 'Bank Branch Name',
    BankNumber: 'Bank Account Number',
    BankBookImage: 'Bank Book Image',
    Upload: 'Upload',
    TaxInfo: 'Tax Information',
    TaxId: 'Taxpayer Identification Number',
    AddressCard: 'Address as per ID card',
    AddressNo: 'House No.',
    RoomNo: 'Room No.',
    Floor: 'Floor',
    Building: 'Building',
    Village: 'Village',
    Moo: 'Moo',
    Soi: 'Alley/Lane',
    Intersection: 'Intersection',
    Road: 'Road',
    SubDistrict: 'Subdistrict',
    District: 'District',
    Province: 'Province',
    PostalCode: 'Postal Code',
    IsAccountType: {
      Savings: 'Savings Account',
      FixedDeposit: 'Fixed Deposit Account',
      Current: 'Current Account'
    },
    PaymentForm: {
      SelectAccountType: 'Select Account Type',
      EnterAccountName: 'Enter Account Name',
      SelectBankName: 'Select Bank Name',
      EnterBankBranch: 'Enter Bank Branch Name',
      EnterBankNumber: 'Enter Bank Account Number',
      EnterTaxId: 'Enter Taxpayer Identification Number',
      EnterAddressNo: 'Enter House Number',
      EnterRoomNo: 'Enter Room Number',
      EnterFloor: 'Enter Floor',
      EnterBuilding: 'Building, Apartment, or Condominium Name',
      EnterVillage: 'Village Name',
      EnterMoo: 'Enter Moo',
      EnterSoi: 'Enter Alley/Lane',
      EnterIntersection: 'Enter Intersection',
      EnterRoad: 'Enter Road Name',
      EnterSubDistrict: 'Enter Subdistrict',
      EnterDistrict: 'Enter District',
      EnterProvince: 'Enter Province',
      EnterPostalCode: 'Enter Postal Code'
    },
    Validation: {
      SelectAccountType: 'Please select account type',
      EnterAccountName: 'Please enter account name',
      SelectBankName: 'Please select bank name',
      EnterBankBranch: 'Please enter bank branch name',
      EnterBankNumber: 'Please enter bank account number',
      NumbersOnly: 'Please enter numbers only',
      EnterTaxId: 'Please enter taxpayer identification number',
      TaxIdLength: 'Tax ID must be 13 digits and numbers only',
      InvalidTaxId: 'Invalid taxpayer identification number',
      EnterAddressNo: 'Please enter house number',
      EnterValidData: 'Please enter valid information',
      InvalidInput: 'Invalid input',
      DigitsOnly: 'Digits only',
      MaxCharacters: 'Maximum 120 characters allowed'
    },
    UpdateSuccess: 'Updated successfully',
    FileSizeExceeded: 'File size exceeds 5 MB',
    InvalidFileType: 'Only JPEG, PNG, JPG formats are allowed',
    FileTooLarge: 'Please upload an image smaller than 5 MB',
    AllowOnlyImage: 'Only image files with jpeg/jpg/png are allowed',
    Edit: 'Edit',
    Cancel: 'Cancel',
    Save: 'Save',
    Close: 'Close',
    InvalidInfo: 'Invalid information',
    TaxInvoiceName: 'Name for Tax Invoice'
  },
  SocialMediaSettings: {
    Title: 'Social Media Account Settings',
    Facebook: 'Facebook',
    TikTok: 'TikTok',
    Youtube: 'Youtube',
    Instagram: 'Instagram',
    Line: 'Line',
    Twitter: 'Twitter (X)',
    EnterLink: 'Enter link',
    UpdateSuccess: 'Update successful',
    UpdateFailed: 'Update failed',
    RequireAtLeastOne: 'Please enter at least one social media account',
    Edit: 'Edit',
    Cancel: 'Cancel',
    Save: 'Save'
  },
  MenuBuyer: {
    titleUserProfile: 'User Information',
    menuMyProfile: 'My Information',
    menuBankAccount: 'Bank Account',
    menuShippingAddress: 'Shipping Address',
    menuFavoriteProduct: 'Favorite items',
    menuCouponPoint: 'My Coupons and Points',
    titleManageOrders: 'Order Management',
    menuMyOrders: 'Order list',
    menuProfileRecord: 'My purchase',
    menuReview: 'Review',
    titleAffiliate: 'Affiliate Program',
    menuShopSeller: 'Affiliate Shops',
    menuProductAffiliate: 'Affiliate Products',
    menuEditPay: 'Payment Settings',
    menuEditSocial: 'Social Settings',
    menuMyShared: 'Dashboard Affiliate',
    menuClick: 'Click Report',
    menuOrderAffiliate: 'Order Report',
    menuWithdraw: 'Withdrawal History',
    titleChat: 'Chat',
    menuMyChat: 'My Chat',
    titleManageSales: 'Manage Sales Order',
    breadcrumbHome: 'Home',
    FriendGetFriends: 'Invite Friends',
    DirectDeal: {
      couponProduct: 'Participating products',
      MyDirectDeal: 'My Direct Deals',
      DirectDealDetails: 'Direct Deal details',
      OrderStatus: 'Order Status',
      Search: 'Search',
      StatusAll: 'All',
      StatusPending: 'Deal Pending',
      StatusApprove: 'Deal Approved',
      StatusReject: 'Deal Rejected',
      status: 'Status',
      product: 'Product',
      DealOffer: 'Deal Offer',
      RequestDate: 'Request Date',
      ProcessedDate: 'Processed Date',
      NotFound: 'No direct deal records found',
      NoData: 'You have no direct deal records yet',
      ContactSeller: 'Contact seller',
      Details: 'Details',
      DealRequestDate: 'Deal request date',
      DealOfferDetail: 'Deal Offer',
      DiscountType: 'Discount Type',
      DiscountAmount: 'Discount Amount',
      DiscountTypePercent: 'Discount by percentage (%)',
      DiscountTypeBaht: 'Discount by amount',
      ShopApprovalDate: 'Approval date',
      Remark: 'Remark',
      Remark1: 'Discount coupons can be used on the cart page.',
      ProductImage: 'Deal product image',
      DetailProductDirectDeal: 'Product details for deal request',
      email: 'E-mail',
      phone: 'Phone',
      address: 'Address',
      Productdetails: 'Product details',
      UnitPrice: 'Unit price',
      BuyNow: 'Add to Cart',
      Discount: 'Discount',
      ReceivedCoupons: 'Received Coupons'
    },
    menuLiveStreaming: 'Live Streaming',
    menuFollowedShop: 'Follow Shop',
    myMember: 'My Member'
  },
  liveStream: {
    spacialDeal: 'Special price from live',
    limit: 'limit',
    Piece: 'piece'
  },
  PobuyerRecord: {
    title: 'My purchase',
    search: 'Search for product name or shop name',
    viewShop: 'View Shop',
    orderDate: 'Order Date',
    quantity: 'Quantity',
    orderSummary: 'Order Summary',
    addCart: 'Add To Cart',
    reorder: 'Reorder',
    discount: 'Discount',
    noOrder: 'There are no orders yet',
    textAddCart: 'Added to cart',
    textHaveProduct: 'This item is already in your cart',
    textIncomplete: 'Information is incomplete',
    textInsert: 'Quantity must be at least 1',
    textNotFoundAttribute: 'Please select a product option first',
    textUnable: 'Unable to proceed',
    textReAdd: 'This item is already in your cart, but it has been updated. Please remove it from your cart and add it again',
    textAddOnly: 'You can add up to 30 items to the cart only'
  },
  MyOrders: {
    title: 'Order list',
    search: 'Search by order ID and shop name',
    orderStatus: 'Order Status',
    statusAll: 'All',
    OrderNumber: 'Order Number',
    statusSuccess: 'Success',
    statusCancel: 'Cancel',
    statusPending: 'Pending',
    statusApprove: 'Approve',
    statusFail: 'Fail',
    statusNotPaid: 'Not Paid',
    orderDate: 'Order Date',
    formatDate: 'DD/MM/YYYY',
    btnCancel: 'Cancel',
    btnConfirm: 'Confirm',
    btnSave: 'Save',
    shop: 'Shop',
    cancelOrder: 'Cancel Order',
    refundOrder: 'Refund Order',
    confirmRefund: 'Confirm Refund',
    payment: 'Payment',
    review: 'Reviews',
    received: 'Order Received',
    reorder: 'Reorder',
    totalOrder: 'Total Items',
    paymentSuccess: 'Payment Successful',
    pickedUp: 'Parcel Registered',
    cod: 'Cash on Delivery',
    shippingInprogress: 'Shipping in Progress',
    delivered: 'Delivered',
    pendingPayment: 'Pending Payment',
    generalProduct: 'General Product',
    serviceProduct: 'Service Product',
    attribute: 'Attribute',
    quantity: 'Quantity',
    price: 'Price',
    totalPrice: 'Total Price',
    seeMore: 'See More',
    freeGift: 'Free Gift',
    noOrderAt: "You don't have any orders",
    noOrder: "You don't have any orders",
    selectPayment: 'Select Payment',
    installmentTerm: 'Installment Term',
    selectTerm: 'Select installment term',
    scanQR: 'Scan QR Code to Pay',
    btnSaveImage: 'Save Image',
    paymentAmount: 'Payment Amount',
    referenceCode: 'Reference Code',
    stepMobile: 'You can make the payment by following these steps (for mobile payments)',
    capture: 'Press the "Save Image" button or take a screenshot',
    caseiOS: 'In case of iOS',
    clickSave: 'Take a screenshot, or press and hold the image, then tap the button',
    saveToApp: 'Save to Photos app',
    selectMenuScan: 'Open your banking app and select the Scan QR Code menu',
    selectScreenshot: 'Select the screenshot to scan the QR Code',
    refundAccount: 'Refund account',
    reasonCancel: 'Reason for order cancellation',
    reasonCancelPlaceholder: 'Please specify the reason for cancelling the order',
    textAddAccount: 'No account information found. Please add an account to receive refunds',
    accountName: 'Bank account name',
    textEnterName: 'Enter the bank account name',
    bankName: 'Bank name',
    textEnterBank: 'Please select your bank',
    accountNumber: 'Bank account number',
    textAccountNumber: 'Enter the bank account number',
    textRefund: 'Are you sure you want to cancel',
    textCancelBySeller: 'Are you sure you want to refund',
    textThisOrder: 'this order',
    textRefundOrder: 'this order',
    cancelSuccess: 'The order has been successfully cancelled',
    refundSuccess: 'The refund has been successfully processed',
    textHaveCancel: 'You have successfully cancelled the order',
    receivedRefund: '*you will receive a refund at 10:00 PM.',
    receivedRefund2: '*you will receive a refund in 24 hours.',
    byDate: 'by the date approved by the shop',
    SuccessRefund: 'Refund request successful',
    image: 'Image',
    productName: 'Product Name',
    thCreateAt: 'Create at',
    thTransactionNumber: 'Transaction number',
    thTransactionStatus: 'Transaction status',
    thReceipt: 'Receipt number',
    thPaymentIcon: 'Quotation',
    thInvoice: 'Invoice',
    thTransactionCode: 'Transaction code',
    thPaidDate: 'Paid date time',
    thPayment: 'Payment',
    thShop: 'Shop name',
    thTransportation: 'Transportation status',
    thNotReceipt: 'Not received',
    thReceived: 'Received',
    UnableCancel: 'Unable to cancel the order',
    textError: 'System error: Unable to reorder at this time',
    textCopy: 'Copied successfully',
    textConfirmReceipt: 'Confirmed inspection and receipt of the goods',
    textPlsSelect: 'Please select the order date',
    textNotSend: 'The item is being shipped',
    textSaveSuccess: 'Data saved successfully',
    textNotFoundInvoice: 'Tax invoice not found',
    textNotFree: 'Some items are not sufficient to qualify for the free gift, including: ',
    textContact: ' please contact the staff',
    textNoDataProduct: 'Some items no longer exist in the system, including: ',
    textNotEnough: 'Some items are insufficient for purchase, including: ',
    textUnablePayment: 'Unable to complete the payment',
    textForGeneral: 'For general customers only',
    textErrorPayment: 'There is a problem with the payment system',
    textPaymentError: 'ERROR: Unable to process payment',
    Fail: 'A system error has occurred. Please contact support.',
    Paymentincomplete: 'Payment Incomplete',
    textConfirmPay: 'Do you want to proceed with this action? Yes or No?',
    ConfirmReceipt: 'Delivery confirmed',
    PayDate: 'Payment Date',
    PayTime: 'Payment Time',
    Amount: 'Amount (Baht)',
    error1: 'Please enter the amount.',
    error2: 'Only numbers and decimals can be entered.',
    error3: 'Please select a date.',
    error4: 'Please select payment time.',
    textNoPayment1: 'No payment account found',
    textNoPayment2: 'Please add a payment account',
    textNoPayment3: 'on the "Payment Account" page',
    SavingGold: 'Saving Gold',
    CancelPayment: 'Cancel Payment'
  },
  DetailOrderBuyer: {
    ConfirmDeleteAddress: 'Confirm Delete Address',
    TextConfirmDeleteAddress: 'Are you sure you want to delete the shipping address?',
    EditAddress: 'Edit Address Successfully',
    TextEditAddress: 'You have successfully edit the shipping address',
    DeleteAddress: 'Delete Address Successfully',
    TextDeleteAddress: 'You have successfully deleted the shipping address',
    Return: 'Return',
    Name: 'Name',
    Address: 'Address',
    Phone: 'Phone',
    No: 'No.',
    RoomNo: 'Room No.',
    Floor: 'Floor',
    Building: 'Building',
    Village: 'Village',
    Moo: 'Moo',
    Soi: 'Alley/Lane',
    Intersection: 'Intersection',
    Road: 'Road',
    SubDistrict: 'Subdistrict',
    District: 'District',
    Province: 'Province',
    PostCode: 'Post Code',
    NameInput: 'Input Name',
    LastNameInput: 'Input Last Name',
    PhoneInput: 'Input Phone',
    NoInput: 'Input No.',
    RoomNoInput: 'Input Room No.',
    FloorInput: 'Input Floor',
    BuildingInput: 'Input Building',
    VillageInput: 'Input Village',
    MooInput: 'Input Moo',
    SoiInput: 'Input Alley/Lane',
    IntersectionInput: 'Input Intersection',
    RoadInput: 'Input Road',
    SubDistrictInput: 'Input Subdistrict',
    DistrictInput: 'Input District',
    ProvinceInput: 'Input Province',
    PostCodeInput: 'Input Post Code',
    DeliveryInformation: 'Delivery Information',
    TextCanEditOnlyOneTime: 'Can edit 1 time only',
    AddAddressSuccess: 'Delivery address added successfully',
    TextAddAddressSuccess: 'You have successfully added the delivery address',
    DefaultAddress: 'Default Address',
    ChangeAddress: 'Change Address',
    OrderDetails: 'Order Details',
    CancelOrder: 'Cancel Order',
    TrackCancellationRequest: 'Track Cancellation Request',
    ItemReceived: 'Item received',
    ProductReview: 'Product Review',
    OrderAgain: 'Order Again',
    UploadSlip: 'Upload Slip',
    OrderStatus: 'Order Status',
    OrderNumber: 'Order ID',
    NewOrder: 'New Order',
    PaymentSuccessful: 'Order Paid',
    EnterInformation: 'Enter Information',
    PreparingForShipment: 'Preparing to ship',
    OutForDelivery: 'Order Shipped Out',
    DeliverySuccessful: 'Delivery',
    OrdersWithCompletedPayment: 'Orders with completed payment',
    OrderHasBeenShipped: 'Order has been shipped',
    BuyerReviewedAndRequestedReturn: 'Buyer reviewed and requested a return',
    WaitingForRefundApproval: 'Waiting for refund approval',
    RefundSuccessful: 'Refund Successful',
    WaitingForPickup: 'Waiting for pickup',
    ReceivedSuccessfully: 'Received Successfully',
    ToReceived: 'To be received',
    DataNotFound: 'Data not found',
    ShippingMethod: 'Shipping Options',
    DocumentDetails: 'Document Details',
    QuotationNumber: 'Quotation Number',
    PurchaseOrderNumber: 'Purchase Order Number (PO NO.)',
    ImageOther: 'photos',
    ReceiptNumber: 'Receipt Number',
    PRNumber: 'Purchase Requisition Number (PR)',
    SONumber: 'Sale Order Number',
    PickupAddress: 'Pickup Address',
    ShippingAddress: 'Shipping Address',
    ShippingAddress2: 'Shipping Address',
    PickUpAtStore: 'Pick Up At Store',
    Remarks: 'Remarks',
    TaxInvoiceDeliveryAddress: 'Tax Invoice Address',
    OrderList: 'Order List',
    GeneralProducts: 'General Products',
    ServiceProducts: 'Service Products',
    FreeGift: 'Free Gift',
    Payment: 'Payment',
    PriceExcludingVAT: 'Price Excluding VAT',
    VAT: 'VAT',
    PriceIncludingVAT: 'Price Including VAT',
    StoreDiscountSummary: 'Store Discount Summary',
    ShippingDiscountSummary: 'Shipping Discount Summary',
    PointsDiscountSummary: 'Points Discount Summary',
    MemberDiscountSummary: 'Member Discount',
    BundleDealDiscountSummary: 'Bundle Deal Discount Summary',
    SystemDiscountSummary: 'System Discount Summary',
    SubTotal: 'Subtotal',
    SubTotalNoVat: 'Subtotal (excluding VAT)',
    SubTotalVat: 'Subtotal (including VAT)',
    ShippingFee: 'Shipping Fee',
    ShippingDiscountSeller: 'Shipping Discount Seller',
    ShippingDiscountNexgen: 'Shipping Discount Nexgen',
    TotalPriceAll: 'Total Price',
    PendingPayment: 'Pending Payment',
    PaymentSuccessfully: 'Payment Successful',
    PaymentMethod: 'Payment Method',
    YourOrderHasBeenCancelled: 'Your order has been cancelled',
    CancelledOrderDetails: 'Cancelled Order Details',
    Approver: 'Approver',
    Approve: 'Approve',
    NotApprove: 'Not Approve',
    WaitingForApproval: 'Waiting Approve',
    ApprovalDate: 'Approval Date',
    YourPaymentWasUnsuccessfulPleaseCheckYourPaymentAnd: 'Your payment was unsuccessful. Please check your payment and try again.',
    Payment2: 'Payment',
    YouHaveNotCompletedPayment: 'You have not completed your payment. Please make a payment via Thaidotcom Payment. You can proceed with the payment here',
    DiscountCoupon: 'Discount Coupon',
    ListOf: 'List of',
    Employees: 'Employees',
    Department: 'Department',
    Company: 'Company',
    PurchaseDate: 'Date',
    PaymentDate: 'Date',
    PreparingShipmentDate: 'Preparing Shipment Date',
    Date: 'On',
    WaitingConfirmation: 'Waiting for confirmation',
    ShippingDate: 'Shipping Date',
    ReturnDate: 'Return Date',
    CancelDate: 'Cancel Date',
    RefundDate: 'Refund Date',
    CashPayment: 'Cash Payment',
    ReceivingDate: 'Receiving Date',
    PRNumber2: 'Purchase Requisition Number (PR)',
    RemarksToSeller: 'Remarks to Seller',
    Baht: 'Baht',
    refundAccount: 'Refund account',
    reasonCancel: 'Reason for order cancellation',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    textAddAccount: 'No account information found. Please add an account to receive refunds',
    accountName: 'Bank account name',
    textEnterName: 'Enter the bank account name',
    BankName: 'Bank Name',
    textEnterBank: 'Please select your bank',
    BankAccountNumber: 'Bank account number',
    textAccountNumber: 'Enter the bank account number',
    BuyerName: 'Buyer Name',
    CancelOrderSuccess: 'You have successfully cancelled the order',
    CreateAt: 'Create at',
    Status: 'Status',
    SellerReason: "Seller's Reason",
    PleaseEnterCancellationReason: 'Please enter the reason for cancellation',
    ScanQRCodeForPayment: 'Scan QR Code for Payment',
    btnSaveImage: 'Save Image',
    TotalPaymentAmount: 'Total Payment Amount',
    referenceCode: 'Reference Code',
    CanMakePaymentByFollowingStep: 'You can make a payment by following these steps (for mobile payment)',
    capture: 'Press the "Save Image" button or take a screenshot',
    caseiOS: 'In case of iOS',
    clickSave: 'Take a screenshot, or press and hold the image, then tap the button',
    saveToApp: 'Save to Photos app',
    selectMenuScan: 'Open your banking app and select the Scan QR Code menu',
    selectScreenshot: 'Select the screenshot to scan the QR Code',
    selectPayment: 'Select Payment',
    installmentTerm: 'Installment Term',
    selectTerm: 'Select installment term',
    InstallmentPaymentNotAvailableBecause: 'Installment payment is not available because the',
    Min: 'Min',
    Max: 'Max',
    RequiredAmountHasNotBeenMet: 'required amount has not been met',
    ComfirmModal: 'Do you want to proceed with this transaction? Yes or No',
    textcancel: 'Are you sure you want to cancel',
    textConfirmRefund: 'Are you sure you want to refund',
    textThisOrder: 'this order',
    cancelSuccess: 'The order has been successfully cancelled',
    textHaveCancel: 'You have successfully cancelled the order',
    receivedRefund: '*you will receive a refund at 10:00 PM.',
    byDate: 'by the date approved by the store',
    SelectImage: 'Select Image',
    FileExtensions: 'File Extensions: .JPEG, .PNG, .JPG',
    ChangeShippingAddress: 'Change Shipping Address',
    Edit: 'Edit',
    Delete: 'Delete',
    Notation: 'Notation',
    NoAddress: 'No shipping address',
    AddAddress: 'Add New Address',
    DeleteShippingAddress: 'Delete Shipping Address',
    textDeleteShippingAddress: 'Do you want to proceed with this transaction? Yes or No',
    ProductDetails: 'Product Details',
    UnitPrice: 'Unit Price',
    Quantity: 'Quantity',
    TotalPrice: 'Total Price',
    Amount: 'Amount',
    validateAccountNumber1: 'Please enter account number',
    NoInstallment: 'No Installment',
    Month: 'Month',
    PricePerMonth: 'Price per month',
    ShippingAddressChanged: 'Shipping address changed successfully',
    AddShippingAddress: 'Add Shipping Address',
    EditShippingAddress: 'Edit Shipping Address',
    FailedToDeleteTheShippingAddress: 'Failed to delete the shipping address',
    AllowOnlyImage: 'Only image files',
    UploadSlipSuccess: 'Upload Slip Success',
    CanNotUploadSlip: 'Can not upload slip',
    SystemErrorUnableToPlaceTheOrderAgain: 'System error: Unable to place the order again',
    SomeItemsRequirementsForFreeGift: 'Some items do not meet the requirements for the free gift, including: ',
    PleaseContactCustomerSupport: ' Please contact customer support',
    PleaseRemoveTheseItemsFromYourCart: 'Please remove these items from your cart',
    ShoppingCartNotFound: 'Shopping Cart Not Found',
    SomeItemsAreNoLongerAvailableInTheSystem: 'Some items are no longer available in the system:',
    PleaseRemoveThemFromYourCart: 'Please remove them from your cart',
    SomeItemsAreNotAvailableInSufficientQuantityForPurchase: 'Some items are not available in sufficient quantity for purchase:',
    TheTotalPriceMustBeGreaterThanZerobaht: 'The total price must be greater than 0 baht',
    PleaseEnterDiscountThatDoesNotExceedTheProductPricel: 'Please enter a discount that does not exceed the product price',
    UnableCancelTheOrder: 'Unable to cancel the order',
    PendingPayments: 'Pending Payment',
    ItemDelivered: 'Item delivered',
    LotusStatus: 'Pending',
    SellerPreparingTheParcel: 'Seller preparing the parcel',
    SellerPreparingTheParcel2: 'Seller preparing the parcel',
    pickedUp: 'Parcel Registered',
    shippingInprogress: 'Shipping in Progress',
    BuyAgain: 'BuyAgain',
    waitingRefund: 'Waiting for refund',
    InvoiceNumber: 'Invoice Number',
    COD: 'Cash On Delivery',
    InsurancePrice: 'Insurance',
    CODFee: 'COD Fee',
    SavingGold: 'Saving Gold',
    Driver: 'Driver',
    PhoneDriver: 'Phone',
    CarInfo: 'Car information',
    License: 'License plate',
    Tracking: 'Track shipment',
    TransportStatus: 'Transportation status',
    AdditionalServices: 'Additional services',
    PickupPoint: 'Pickup point (for you)',
    DeliveryPoint: 'Delivery point (buyer)',
    ReasonCancleSlip: 'Reason for canceling slip',
    UploadSlipCondition: 'Image file size should not exceed 2 MB and up to 3 images can be uploaded',
    FileExtensionsSlip: 'Supported file extensions: .JPG, .JPEG, .PNG',
    PlaceholderSelectDate: 'Select payment date',
    PlaceholderSelectTime: 'Select payment time',
    UploadImageTitle: 'Drag your images here to upload',
    UploadImageOr: 'or',
    UploadImageCondition: 'Supported file extensions: .JPG, .JPEG, .PNG and file size: up to 2 MB',
    UploadImageLimit: 'Up to 3 images',
    SelectFile: 'File added',
    AddImgSlip: 'Add Images',
    PreviewLabel: 'Preview',
    SwalFileSizeExceed: 'File size must not exceed 2 MB',
    SwalFileTypeNotSupported: 'Only JPG, JPEG, PNG files are supported',
    SwalFileUploadLimit: 'You can upload a maximum of 3 images',
    SwalPleaseSelectImage: 'Please select an image',
    branch: 'Branch',
    BranchNo: 'Branch No'
  },
  reportOrderAffiliate: {
    PageTitle: 'Order Report',
    OrderID: 'Order ID',
    OrderDate: 'Order Date',
    OrderStatus: 'Order Status',
    SearchOrderDate: 'Search by Order Date',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Clear: 'Clear',
    Search: 'Search',
    Total: 'Total',
    Items: 'items',
    NoData: 'No order report found',
    View: 'View',
    NoOrders: 'You have no order reports yet',
    OrderDetailTitle: 'Order Details',
    ProductName: 'Product Name',
    ProductType: 'Product Type',
    ProductAttribute: 'Product Attribute',
    ProductPrice: 'Price',
    Quantity: 'Quantity (pcs)',
    CommissionPercent: 'Commission (%)',
    CommissionBaht: 'Commission (Baht)',
    CommissionValue: 'Commission Amount (Baht)',
    TaxDeducted: 'Tax Deducted (Baht)',
    NetCommission: 'Net Commission (Baht)',
    OrderStatusTitle: 'Order Status',
    TotalCommission: 'Total Commission (Baht)',
    Detail: 'Details',
    All: 'All',
    Success: 'Payment Successful',
    NotPaid: 'Not Paid',
    CancelStatus: 'Order Cancelled',
    Fail: 'Payment Failed',
    Pending: 'Pending',
    Approve: 'Billed',
    Credit: 'Credit Payment',
    DataIncomplete: 'Incomplete Data',
    Refund: 'Refunded'
  },
  DashboardAffiliate: {
    titleWeb: 'Dashboard',
    titleMobile: 'Dashboard Affiliate',
    yearly: 'Yearly',
    monthly: 'Monthly',
    daily: 'Daily',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    display: 'Display',
    titleSelectMonth: 'Select Month',
    formatDate: 'DD/MM/YYYY',
    btnCancel: 'Cancel',
    btnConfirm: 'Confirm',
    btnSave: 'Save',
    filter: 'Filter',
    clsValue: 'Clear',
    selectShop: 'Select Shop',
    allLinks: 'All Links',
    incomeInfo: 'Income Information',
    commission: 'Commission List per Link',
    topClick: 'Top 10 Most Clicked Products',
    topSeller: 'Top 10 Best Seller Products',
    clickInfo: 'Click Information',
    incomeGraph: 'Income Graph',
    theCommission: 'Commission',
    clickGraph: 'Click Graph',
    clicking: 'Clicking',
    totalCommission: 'Total Commissions',
    unit: 'baht',
    totalClicks: 'Total Clicks',
    unitClick: 'times',
    unitOrder: 'Items',
    noClick: 'No click records',
    numberClicks: 'Number of Clicks',
    totalPeriods: 'Total Across All Periods',
    noPurchase: 'No purchase records',
    commissionFee: 'Commission Fee',
    items: 'items',
    productList: 'Product List',
    AllProductsList: 'All Product List',
    productType: 'Product Type',
    attribute: 'Product Attributes',
    price: 'Price',
    commissionIncome: 'Commission Income',
    orderDetail: 'Order Details',
    productName: 'Product Name',
    quantity: 'Quantity',
    taxDeduction: 'Tax Deduction',
    Jan: 'January',
    Feb: 'February',
    Mar: 'March',
    Apr: 'April',
    May: 'May',
    Jun: 'June',
    Jul: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December',
    link: 'Link',
    status: 'Status',
    thPrice: 'Price (baht)',
    thComProduct: 'Product Commission',
    thComPrice: 'Commission (baht)',
    attributeList: 'Attribute List',
    quantitySold: 'Quantity Sold (items)',
    influPayment: 'Commission Income (baht)',
    textSeries: 'Commission Amount',
    textSeriesClick: 'Number of Clicks',
    allShop: 'All',
    typeLanguage: 'en-EN',
    linkStatusAc: 'Active',
    linkStatusIn: 'In Active',
    excelCommission: 'Commission Table',
    excelTopProducts: 'Top 10 Products',
    textLinkCopy: 'Link copied successfully'
  },
  ProductCard: {
    AlreadySold: ' ',
    Sold: 'Sold',
    OutOfStock: 'Out of Stock',
    ContactSupport: 'Contact Support'
  },
  ModalMenu: {
    titleSeller: 'My Company',
    textSearchSeller: 'Search by Company Name',
    unitOrder: 'Items',
    addCompany: 'Add Company',
    noData: 'No company found in the table',
    noResults: 'Company not found in the table',
    numberRows: 'Number of rows',
    selectCompany: 'Select Company',
    shopList: 'Shop List',
    myShop: 'My Shops',
    textSearchName: 'Search by Shop Name',
    noDataShop: 'No shop found in the table',
    noResultsShop: 'Shop not found in the table',
    selectShop: 'Select Shop',
    positionCompany: 'Company Position',
    myPosition: "My company's position",
    noDataPosition: 'No position records found in the table',
    noResultsPosition: 'No job positions found in the table',
    list: 'List',
    selectPosition: 'Select Position',
    listBusiness: 'List of Business',
    myBusiness: 'My Business',
    regisBusiness: 'Register Business',
    noDataCor: 'My business is not listed in the table',
    noResultsCor: 'No business found in the table',
    selectCor: 'Select Business',
    textSearchCor: 'Search by business name',
    saleOrderFormat: 'Sale Order format',
    orderForCus: '* Ordering for the customer',
    orderInet: '* Internal ordering at INET',
    general: 'General',
    externalCus: '* Orders for external customers (companies or individuals)',
    listPartner: 'List of partners',
    myPartners: 'My partners',
    textSearchPartners: 'Search by partner company name',
    noDataPartner: 'No partners of my company are found in the table',
    noResultsPartner: 'No partner company listed in the table',
    selectPartner: 'Select Partner',
    no: 'No.',
    companyName: 'Company Name',
    shopName: 'Shop Name',
    partnerName: 'Partner Name',
    nameCor: 'Name of business',
    notPermission: 'You do not have this permission in the system',
    textContact: ' please contact the staff',
    noID: 'No Business ID',
    createCompany: 'Please create a company',
    createComSuccess: 'Company created successfully',
    noDataYourCor: 'No information found for your legal entity',
    role: 'role : ',
    company: '   Company : ',
    plsLogin: 'Please log in again',
    channelNot: 'Channel not found. Please check and try again',
    shopNot: 'Shop not found. Please check and try again',
    employNot: 'Employee information not found. Please check and try again',
    shopNo: 'Shop not found',
    noAccess: 'Not access this function',
    noBus: 'Your business entity information was not found',
    noRegis: 'You have not yet registered a business account. Would you like to sign up?',
    regis: 'Register',
    myPurchaser: 'My Purchaser',
    selectPurchaser: 'Select Purchaser',
    textSearchPurchaser: 'Search by Purchaser Name',
    WaitingApproveBusiness: 'Your business entity is awaiting approval.'
  },
  FlashSale: {
    tomorrow: 'Tomorrow',
    ongoing: 'Ongoing',
    comingSoon: 'Coming Soon',
    flashSaleComingSoon: 'Flash Sale is coming soon'
  },
  ProductCardFlashSale: {
    Sold: 'Sold'
  },
  CreateShop: {
    TitleCreate: 'Create Shop',
    Description: 'Create your shop to start selling products with us.',
    GeneralInfo: 'General Information',
    ShopAddress: 'Shop Address',
    AdImage: 'Advertisement Image',
    NoteAd: 'Note: You can upload the advertisement image later',
    ShopImage: 'Shop Image',
    SizeImage: 'File size: Up to 3 MB',
    ShopProfile: 'Upload shop logo image.',
    ShopBanner: 'Upload shop banner image.',
    // ShopProfile: 'Shop Profile',
    SizeImgProfile: '(244 x 244 px image, accepted formats: .JPEG, .PNG, .JPG)',
    MaxSizeImgProfile: 'Maximum file size 3 MB',
    UploadImg: 'Upload Image',
    Loading: 'Uploading...',
    BtnCancel: 'Cancel',
    BtnEdit: 'Edit',
    BtnDelete: 'Delete',
    ShopCover: 'Shop Cover',
    SizeCover: '(Image size: 1376 x 380 px, file formats: .JPEG, .PNG, .JPG, maximum 6 images can be uploaded)',
    UpMore: 'Upload More Images',
    BusinessType: 'Business Type',
    ShopName: 'Shop Name',
    // ShopName: 'Shop Name (TH)',
    ShopName_en: 'Shop Name (EN)',
    TextShopName: 'Enter Shop Name',
    TaxIdNum: 'Tax ID Number',
    TextTaxId: 'Enter your 13-digit Tax ID Number',
    ShopURL: 'Shop URL',
    TextURl: 'Enter the shop URL',
    ShopDetail: 'Shop Detail',
    DescriptionShop: 'Enter describe your Shop.',
    ShopAbbreviation: 'Shop Abbreviation',
    MaxAbbreviation: 'Shop Abbreviation',
    DesAbbreviation: 'Abbreviation to be used in the run number of the Cost Sheet and PO for each JV.',
    PhoneMobile: 'Phone Number / Mobile Number',
    TextPhoneMobile: 'Enter your phone number/mobile number',
    TextFacebook: 'Enter your facebook url',
    TextWebURL: 'Enter your web url',
    TextLine: 'Enter your ID LINE',
    StatusInfo: 'Shop Opening and Closing Information',
    Status: 'Status',
    Open: 'On',
    Close: 'Off',
    PartnerInfo: 'Partnership Request Information',
    PartnerOn: 'Partnership On',
    PartnerOff: 'Partnership Off',
    ShippingInfo: 'Shipping Information',
    SelectShipping: 'Select Shipping Option',
    TextSelectShipping: 'Select Shipping Option',
    BtnClear: 'Clear',
    BtnNext: 'Next',
    NotUseShiping: 'Do not use system shipping',
    UseShiping: 'Use system shipping',
    ApproveCreate: 'Approve Shop Creation',
    ShopComplete: 'Shop information is complete',
    WaitEmail: 'Waiting to receive the electronic contract via email.',
    SaveData: 'Save Data',
    HaveCreate: 'You have created a shop',
    ComfirmCreate: 'Do you want to proceed with this transaction? Yes or No',
    BtnConfirm: 'Confirm',
    SaveComplete: 'Save completed',
    SaveSuccess: 'You have successfully created a shop.',
    BtnOK: 'Confirm',
    NotPass: 'Your shop did not pass the system verification',
    ShopNotApprove: 'Your shop was not approved',
    Because: 'Because',
    UploadCover: 'Upload Shop Cover Page',
    MaxImage: '(Maximum 6 images)',
    DragImage: 'Drag your images here to upload',
    Or: 'Or',
    SelectImg: 'Select Image',
    MaxUploadCover: '(Image size: 1376 x 380 px; file formats: .JPEG, .PNG, .JPG; maximum file size: 3 MB)',
    FileAdd: 'File added',
    FileLarge: 'The file is too large',
    Preview: 'Show preview',
    Upload: 'Upload',
    UpAd: 'Upload ad image',
    MaxImage5: '(Maximum 5 images)',
    ServiceCharges: 'Payment system service charges',
    AddAddress: 'Add Address',
    FirstName: 'Contact name',
    // FirstName: 'Contact name (TH)',
    FirstNameEn: 'Contact name (EN)',
    TextName: 'Enter the contact name',
    LastName: 'Last Name (TH)',
    LastNameEn: 'Last Name (EN)',
    TextLastName: 'Enter your last name',
    Email: 'Email',
    TextEmail: 'Enter your email',
    PhoneNum: 'Phone Number',
    TextPhone: 'Enter phone number',
    AddressDetail: 'Address Detail',
    // AddressDetail: 'Address Detail (TH)',
    AddressDetail_en: 'Address Detail (EN)',
    TextAddress: 'Enter street, village, and road.',
    // TextAddress: 'Enter address details (excluding house number)',
    HouseNumber: 'House Number',
    TextHouseNum: 'Enter your house number',
    SubDistrict: 'Sub-district',
    TextSubDistrict: 'Enter Sub-district',
    InvalidInfo: 'Invalid information',
    District: 'District',
    TextDistrict: 'Enter District',
    Province: 'Province',
    TextProvince: 'Enter Province',
    Zipcode: 'Zipcode',
    TextZipcode: 'Enter Zipcode',
    SetAddress: 'Set as default address',
    BtnBack: 'Back',
    AddAdImg: 'Add Ad Image',
    SizeAd: '(Image size: 1376 x 380 px, file formats: .JPEG, .PNG, .JPG, maximum 5 images can be uploaded)',
    UpList: 'Upload List',
    SortImg: '(The sorting order determines the display order of images on the shop page.)',
    BtnSave: 'Save',
    TitleQRPayment: '1. QR Code Payment',
    CasePayment: 'In case of',
    Less500: 'Transaction amount is less than 500 baht',
    ExclVAT: '(excl. VAT)',
    More500: 'Transactions of 500 baht or more',
    InclVat: '(incl. VAT)',
    TitleCredit: '2. Payment by Credit or Debit Card',
    CaseCredit: 'The system supports credit/debit cards from all banks, with',
    Fee: 'Fee',
    Months3: '3 months',
    Months6: '6 months',
    Months10: '10 months',
    EnterInfo: 'Please enter the information',
    PlsSelect: 'Please select the information',
    PlsDepartment: 'Please enter sales dept. name',
    PlsShopName: 'Please enter the shop name',
    PlsShortName: 'Please enter the shop short name',
    Enter5chars: 'Enter shop abbreviation (max 5 chars)',
    EnterOnlyShort: 'Please enter letters and numbers only',
    NoLeadingSpace: 'The first character of the short name cannot be a space',
    PlsTaxID: 'Please Enter the tax ID number',
    PlsMaxTaxID: 'Please enter the 13-digit tax ID number',
    PlsEnterName: 'Please enter your first name',
    PlsLaseName: 'Please enter your last name',
    PlsEnterPhone: 'Please enter your phone number',
    PlsEnterFirst0: 'Please enter the first 0',
    PlsMaxPhone: 'Phone number must be 9 or 10 digits',
    PlsEnterMobile: 'Please enter a valid phone or mobile number',
    TextInvalidPhone: 'Invalid phone number',
    PlsEnterAddress: 'Please enter your address',
    PlsEnterEmail: 'Please enter your email',
    PlsEnterCode: 'Please enter the payment code',
    PlsSelectBusType: 'Please select your business type',
    PlsSelectPaymentMethod: 'Please select a payment method',
    PlsSelectContract: 'Please select the contract type',
    PlsSelectChanel: 'Please select a payment channel',
    PlsSelectShipping: 'Please select a shipping',
    PlsSelectBank: 'Please select a bank',
    PlsSelectInstallment: 'Please select an installment plan',
    NoPickUp: 'No Pick Up',
    PickUp: 'Pick Up',
    LimitImage6: 'Upload limit: 6 images',
    ImgOnly: 'Upload images only',
    MaxImageAllow: 'Maximum 6 images allowed',
    LimitImage5: 'Upload limit: 5 images',
    MaxImageAllow5: 'Maximum 5 images allowed',
    RoomNo: 'Room No. ',
    Floor: 'Floor ',
    Village: 'Village ',
    VillageNo: 'Village No. ',
    Alley: 'Alley ',
    Junction: 'Junction ',
    Road: 'Road ',
    MaxSize244: 'Max image dimensions: 244 x 244 px',
    MaxSizeBanner: 'Max image dimensions: 1376 x 380 px',
    PlsMaxSize244: 'Upload images up to 244 x 244 px only',
    Upload1MB: 'Upload images under 1 MB only',
    PlsCheckMore: 'Please check the information once more',
    PlsChoose: 'Please choose (Sub-district, District, Province, ZIP Code)',
    CanUpload6: 'You can upload up to 6 images',
    TaxInvalid: 'Invalid tax id number',
    AddressInvalid: 'Shop address data is invalid.',
    ShopUse: 'This shop name is already in use',
    URLUse: 'This URL is already in use',
    ShortNameUse: 'This shop abbreviation is already in use',
    ManageShop: 'Manage Shop',
    GoBack: 'Go back to the trading page',
    Interested_eTax: 'Interested in using electronic receipts',
    AddDocs: 'Please add a copy of Form e-Tax invoice & e-Receipt to use the eTax service',
    PlaceHolderDocs: 'copy of Por.Por.20 or Company Registration Document.',
    PlsEnterFile: 'Please fill in the information',
    PlsEnterPDF: 'Please add a PDF file or image file, no larger than 5 MB',
    PlsEnterMaxFile: 'Please add a file no larger than 5 MB',
    BtnClose: 'close',
    ErrorEmpty: 'Please check the information again.',
    PlsError: 'Please provide either a copy of Por.Por.20 (VAT Certificate) or Company Registration Document.',
    NotInterested: 'Not interested in using e-Tax Invoice & e-Receipt services',
    Interested: 'Interested in using e-Tax Invoice & e-Receipt services',
    SelectFuzeBox: 'Types of cold shipping boxes',
    StoreDetail: 'Shop Detail'
  },
  CreateBizShop: {
    RegisterShop: 'Shop Registration',
    RegisterParner: 'Partner Registration',
    ShopInfo: 'Shop Information',
    ShopLogo: 'Shop Logo Image',
    LogoSize: 'Image size: 244 × 244 px',
    SupportFile: 'Image size: 244 × 244 px, supported file formats: .JPEG, .PNG, .JPG',
    ShopBannerImage: 'Shop Banner Image',
    BannerSize: 'Image size: 1376 × 380 px, supported file formats: .JPEG, .PNG, .JPG. You can upload up to 6 images.',
    placeholderShopName: 'Enter the shop name',
    productCategory: 'Product Category',
    placeholderCategory: 'Select a Product Category',
    placeholderDetail: 'Enter details about your shop',
    ShopContact: 'Shop Contact Information',
    Province: 'Province',
    placeholderProvince: 'Select Province',
    District: 'District',
    placeholderDistrict: 'Select District',
    Subdistrict: 'Subdistrict',
    placeholderSubdistrict: 'Select Subdistrict',
    Zipcode: 'Zipcode',
    placeholderZipcode: 'Select Zipcode',
    invalidInfo: 'Invalid information',
    BusinessInformation: 'Business Information',
    BusinessType: 'Business Type',
    ShopType: 'Shop Type',
    JuristicPerson: 'Juristic Person',
    Individual: 'Individual',
    Yes: 'Yes',
    No: 'No',
    corporation: 'corporation',
    CommunityEnterprise: 'Community Enterprise',
    SocialEnterprise: 'Social Enterprise',
    Pracharath: 'Pracharath Rak Samakkhi',
    CommercialRegistration: 'Commercial Registration',
    Interested: 'How did you hear about Nex Gen Commerce',
    CDD: 'Community Development Department, Ministry of Interior (CDD)',
    DBD: 'Department of Business Development, Ministry of Commerce (DBD)',
    OSMEP: 'Office of Small and Medium Enterprises Promotion (OSMEP)',
    SMEBank: 'Small and Medium Enterprise Development Bank of Thailand (SME D BANK)',
    Booth: 'Nex Gen Commerce Platform Booth',
    Staff: 'Nex Gen Commerce Staff',
    Other: 'Other',
    Ordinary: 'Ordinary Partnership',
    Limited: 'Limited Partnership',
    CompanyLimited: 'Company Limited',
    PublicLimited: 'Public Limited Company',
    OtherType: 'Other',
    SelectChannel: 'Select a Channel',
    EventIntered: 'Event that sparked your interest in opening a shop with Nex Gen Commerce',
    EventName: 'Please specify the event name...',
    PartnerIntered: 'Partner that sparked your interest in opening a shop with Nex Gen Commerce',
    PartnerName: 'Please specify the Partner...',
    SocialIntered: 'Social Media that sparked your interest in opening a shop with Nex Gen Commerce',
    SelectSocial: 'Select a Social Media Channel',
    OtherIntered: 'Other channels that sparked your interest in opening a shop with Nex Gen Commerce',
    OtherChanel: 'Please specify other channels...',
    EntrepreneurID: 'Entrepreneur ID',
    EnterEntrepreneurID: 'Enter the Entrepreneur ID',
    BusinessNo: 'Business Registration No',
    EnterBusinessNo: 'Enter the Business Registration No',
    BusinessNoIndividual: 'Tax ID Number',
    EnterBusinessNoIndividual: 'Enter the Tax ID Number',
    JuristicType: 'Juristic Person Type',
    SelectJuristicType: 'Select Juristic Type',
    FirstName: 'First name',
    EnterFirstName: 'Enter First name',
    CompanyName: 'Company Name',
    EnterCompanyName: 'Enter Company Name',
    Lastname: 'Last name',
    EnterLastname: 'Enter Last name',
    SameAddress: 'Is the Registered Address the same as the Shop Address?',
    RegisteredAddress: 'Detail Registered Address',
    AttachDocument: 'Attach Document',
    CopyIDCard: 'Copy of ID Card',
    AttachCopyIDCard: 'Attach a Copy of Your ID Card',
    OpenDocument: 'Open Document',
    PhotoIDCard: 'Photo of the Owner Holding Their ID Card',
    AttachPhotoIDCard: 'Attach Photo of the Owner Holding Their ID Card',
    CopyCertificate: 'Copy of the Company Certificate',
    AttachCopyCertificate: 'Attach Copy of the Company Certificate',
    CopyEnterprise: 'Copy of the Community Enterprise Certificate',
    AttachCopyEnterprise: 'Attach Copy of the Community Enterprise Certificate',
    CommunityCertificate: 'Community Enterprise Certificate',
    AttachCommunityCertificate: 'Attach Community Enterprise Information System Certificate',
    AvailableAt: 'Available at',
    CopySocial: 'Copy of the Social Enterprise Certificate',
    AttachCopySocial: 'Attach Copy of the Social Enterprise Certificate',
    CopyPracharath: 'Copy of the Pracharath Rak Samakkhi Document',
    AttachCopyPracharath: 'Attach Copy of the Pracharath Rak Samakkhi Document',
    CopyRegistration: 'Copy of the Commercial Registration Certificate',
    AttachCopyRegistration: 'Attach Copy of the Commercial Registration Certificate',
    CopyOTOP: 'Copy of the OTOP Registration Certificate',
    AttachCopyOTOP: 'Attach Copy of the OTOP Registration Certificate',
    VatInfo: 'VAT Registration Information',
    RegisVat: 'Are you registered for VAT?',
    PP20: 'VAT Registration Certificate',
    AttachPP20: 'Attach VAT Registration Certificate',
    PP_IDCard: 'VAT Registration Certificate / Taxpayer Identification Card',
    AttachPP_IDCard: 'Attach VAT Registration Certificate / Taxpayer Identification Card',
    Accept: 'Accept',
    BTNBackHome: 'Back to Home',
    BTNBack: 'Back',
    BTNNext: 'Next',
    BTNSave: 'Save',
    EnterInfo: 'Specify details about the shop.',
    Close: 'close',
    SaveData: 'Save data',
    StoreInfo: 'You have completed the shop information and registration.',
    ConfirmSave: 'Are you sure you want to confirm this action?',
    BtnCancel: 'Cancel',
    BtnConfirm: 'Confirm',
    CreateSuccess: 'Create Success',
    HasBeen: 'Shop information and registration have been successfully saved.',
    FailedCreate: 'Failed to create the shop.',
    ContactSupportShop: 'Unable to create the shop. Please contact our support team.',
    ContactSupport1: 'Contact Support',
    AlreadyRegis: 'This Tax ID is already registered.',
    AlreadyRegis1: 'This Tax ID has already been registered.',
    ContactSupport2: 'Please contact our support team.',
    SystemError: 'System error. Please try again later.',
    ContactSupport3: 'Please contact our support team to retry the transaction.',
    FindBiz: 'Business information already exists in the system.',
    AlreadyBizNumber: 'This business registration number already exists in the system.',
    LockData: 'The system will display the existing information and lock the business information fields.',
    BtnConfirm2: 'Confirm',
    HaveShop: 'A shop already exists in the system.',
    SelectShop: 'Please select the shop you would like to log in to.',
    ShopId: 'Shop ID',
    ShopName: 'Shop Name',
    MaxFirstname: 'Please enter no more than 50 characters.',
    PlsEnterEmail: 'Please enter your email address.',
    PlsEnterValidEmail: 'Please enter a valid email address.',
    PlsEnterBizNumber: 'Please enter the business registration number.',
    PlsEnterNumber: 'Please enter numbers only.',
    MaxBizNumber: 'Please enter a 13-digit business registration number.',
    PlsEnterNameCompany: 'Please enter the company name.',
    SpaceCompany: 'The company name cannot start with a space.',
    PlsEnterName: 'Please enter a name.',
    SpaceName: 'The name cannot start with a space.',
    PlasEnterLastname: 'Please enter a last name.',
    SpaceLastname: 'The last name cannot start with a space.',
    SpaceLine: 'Line ID cannot start with a space.',
    SpaceFacebook: 'Facebook cannot start with a space.',
    SpaceAddress: 'Address Detail cannot start with a space.',
    PlsEnterData: 'Please enter data.',
    SpaceCharacter: 'The first character cannot be a space.',
    PlsEnterHouseNumber: 'Please enter the number.',
    PlsEnterLink: 'Please enter a valid website URL.',
    MaxAccessCode1: 'Please enter a 10-digit operator ID.',
    MaxAccessCode2: 'Please enter a 12-digit operator ID.',
    AlreadyShopName: 'This shop name already exists in the system.',
    PlsCheckName: 'Please check the shop name and choose a different name to continue.',
    AlreadyShortName: 'This short name already exists in the system.',
    PlsCheckShortName: 'Please check the short name and choose a different name to continue.',
    PlsCheckData: 'Please review the information and try again.',
    PlsCheckLogoShop: 'Please upload your shop logo.',
    PlsCheckBannerShop: 'Please upload your shop banner.',
    PlsCheckTypeShop: 'Please select a shop type.',
    PlsCheckShopAddress: 'Please complete all shop address information.',
    PlsCheckBizAddress: 'Please complete all registered address information.',
    CheckAddressShop: 'Please check the shop address information and complete all required fields.'
  },
  GroupShopHomepage: {
    TitleAllShops: 'All Shops',
    TitleShop: 'Shop',
    NoProduct: 'No Products',
    SearchByShopName: 'Search by Shop Name',
    Province: 'Province',
    Category: 'Category',
    AllFound: 'All Found',
    NoShops: 'No Shops',
    NoItemsInGroup: 'This Shop Group Has No Items Yet',
    ShopNotFound: 'Shop Not Found',
    ShopSearchNotFound: 'No Shops Found. Please Check Again.',
    Home: 'Home',
    ShopType: 'Shop Type',
    Product: 'Product',
    Shop: 'Shop',
    All: 'All',
    CopyLinkSuccess: 'Link Copied Successfully',
    GoToPage: 'go to page'
  },
  BreadcrumbYourOrder: {
    HomePage: 'Home',
    ShoppingCart: 'Shopping Cart',
    Checkout: 'Checkout',
    YourOrder: 'Your Order'
  },
  CheckName: {
    Save: 'Save',
    Name: 'Name',
    EnterName: 'Enter Name',
    LastName: 'Last Name',
    EnterLastName: 'Enter Last Name',
    Phone: 'Phone Number',
    EnterPhone: 'Enter Phone Number',
    SaveData: 'Save Data',
    YouHaveMadeChanges: 'You have made changes to your personal information',
    DoYouWantProceedTransaction: 'Do you want to proceed with this transaction? Yes or No',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    SavedSuccessfully: 'Saved Successfully',
    SuccessfullyUpdatedYourInformation: 'You have successfully updated your personal information',
    PleaseUsername: 'Please enter your username',
    PleaseEnterPassWord: 'Please enter your password',
    OnlyLettersNumbersAllowed: 'Only letters and numbers are allowed',
    PleaseEnterYourFirstName: 'Please enter your contact name',
    PleaseEnterYourLastName: 'Please enter your last name',
    PleaseEnterYourFullName: 'Please enter your full name',
    PleaseEnterYourPhoneNumber: 'Please enter your phone number',
    PleaseEnterValidPhoneNumber: 'Please enter a 10-digit phone number',
    PleaseEnterYourEmailAddress: 'Please enter your email address',
    PleaseEnterYourUserName: 'Please enter your user name',
    NotEnterMoreName: 'Do not enter more than 30 characters in your name',
    NotEnterMoreSurName: 'Do not enter more than 30 characters in your last name',
    OnlyLettersAllowed: 'Only letters are allowed',
    PleaseEnterValidEmailAddress: 'Please enter a valid email address',
    PleaseEnterEnglishCharactersOnly: 'Please enter English characters only',
    NoSpacesAllowedInEmail: 'No spaces allowed in email',
    CannotProceed: 'Cannot proceed'
  },
  Business: {
    BusinessInfo: 'Business Information',
    BusinessID: 'Business ID',
    OtherBusinessID: 'Other Business ID',
    TextBusinessID: 'Please select business ID registration.',
    GetBusinessOneID: 'Register by pulling data from One ID',
    PleaseTaxID: 'Please provide your tax number.',
    SearchTax: 'search',
    PleaseInputData: 'Please fill in the information.',
    PleaseTaxIDCorrect: 'Invalid tax number',
    PleaseInputBranchID: 'Please enter branch code.',
    PleaseBranchCorrect: 'Please enter the full 5-digit branch code.',
    PleaseInputEmail: 'Please enter your email.',
    PleaseEmailCorrect: 'Please enter a valid email.',
    PleaseEmailNotNull: 'Do not include spaces in emails.',
    PleaseInputThai: 'Please fill in Thai only.',
    PleaseInputEng: 'Please fill in English only.',
    PleaseInputShop: 'Please enter the store name.',
    PleaseInputShopEng: 'Please enter the store name in English.',
    PleaseInputTel: 'Please enter your phone number.',
    PleaseInputAddress: 'Please provide address.',
    PleaseInputCompanyName: 'Please enter the company name (Thai)',
    PleaseInputBusinessName: 'Please enter the business name (Thai)',
    PleaseInputNameDoc: 'Please enter a name to display on the document (Thai)',
    PleaseInputCompanyNameEng: 'Please enter the company name (English)',
    PleaseInputBusinessNameEng: 'Please enter the business name (English)',
    PleaseInputNameDocEng: 'Please enter a name to display on the document (English)',
    PleaseSelectOtherBusinessID: 'Please select other business ID registration.',
    RegisOtherNew: 'Register by filling in new information',
    TypeBusiness: 'Type of Business(Thai)',
    CompanyName: 'Company Name(Thai)',
    NameDoc: 'Name to display on the document(Thai)',
    TypeBusinessEng: 'Type of Business(English)',
    CompanyNameEng: 'Company Name(English)',
    NameDocEng: 'Name to display on the document(English)',
    Email: 'Email',
    BranchName: 'Branch Name',
    BranchCode: 'Branch Code',
    BranchInput: 'Branch Code (Only numbers)',
    TelephoneNum: 'Telephone Number',
    MobileNumber: 'Mobile Number',
    FaxNumber: 'Fax Number',
    TitleTaxStore: "Address as per the store's tax invoice",
    AddressCode: 'Address Code',
    Address: 'Address',
    HouseNumber: 'House No.',
    FloorNo: 'Floor No.',
    Building: 'Building',
    Village: 'Village',
    VillageNo: 'Village No.',
    Alley: 'Alley',
    Junction: 'Junction',
    Road: 'Road',
    Subdistrict: 'Subdistrict',
    District: 'District',
    Province: 'Province',
    PostCode: 'Postcode',
    Cancel: 'Cancel',
    Register: 'Register',
    ModalEKYC: {
      YoureKYC: 'Your eKYC is',
      NotVerified: 'Not verified yet.',
      TextFirst: 'If you have not verified eKYC yet.',
      TextTwo: 'Please verify before.',
      ClickVerified: 'Click here for verify eKYC',
      Expire: 'Expire',
      ReneweKYC: 'Please renew your eKYC.',
      ExpireFirst: 'Before verifying your identity',
      ClickRenew: 'Click here to renew eKYC'
    },
    Businesstype: 'Business Type',
    BusinessName: 'Business name(Thai)',
    BusinessNameEng: 'Business name(English)',
    TaxNumberOther: 'Tax Number(Business Owner)',
    BusinessAddress: 'Business Address',
    MessageAlready: 'You already have business information.',
    MessageWaiting: 'Your business is awaiting approval.',
    OfficeCall: 'Contact an officer',
    MessageSuccess: 'Successfully added business information',
    PleaseCheckInformation: 'Please check the information again.',
    FillInInformation: 'Please fill in all information.',
    Unauthorized: 'This user is unauthorized.',
    TokenNotFound: 'Token not found.',
    NotVerifiedID: 'This user has not been verified Ekyc By ID Card',
    TaxIDDupli: 'This TAX ID is already exist.',
    NotFoundCom: 'The user was not found in the company.',
    NotValidBusinessType: 'Invalid format for business_type_other.',
    CreateOtherFail: 'Create business other failed.',
    TaxNotEKYC: 'id_card_num not approved eKYC.',
    ContractStaff: 'System failure. Please contact the staff.',
    DataRetrieval: 'Data retrieval successful',
    NotFoundBusinessAccount: 'Not Found Business Account'
  },
  ModalAddCustomerSaleOrder: {
    HeaderAddCustomer: 'Add Customer Information',
    HeaderEditCustomer: 'Edit Customer Information',
    CustomerData: 'Inoformation',
    CustomerAddress: 'Address',
    CustomerInvoiceAddress: 'Invoice Address',
    CustomerInvoiceAddressMobile: 'Invoice Addr.',
    GeneralCustomer: 'Individual Customer',
    JVCustomer: 'JV Customer',
    CustomerName: 'Customer Name',
    PlaceHolderCustomerName: 'Enter Customer Name',
    CustomerID: 'Customer ID',
    Phone: 'Phone Number',
    PlaceHolderCustomerID: 'Enter Customer ID',
    TaxId: 'Tax ID',
    PlaceHolderTaxId: 'Enter Tax ID',
    PlaceHolderEmail: 'Enter Email',
    PlaceHolderTel: 'Enter Phone Number',
    CustomerGroup: {
      Headers: 'Customer Group',
      SelectGroup: 'Select Customer Group',
      NotFoundGroup: 'No Customer Group Found',
      TierGroup: 'Customer Group Tier',
      Discount: 'Discount',
      Baht: 'Baht'
    },
    CreditTerm: 'Credit Term (Days)',
    PlaceHolderCreditTerm: 'Enter Credit Term: 1-120 days',
    InstallmentPayment: 'Installment Payment',
    PlaceHolderInstallmentPayment: 'Payment periods: 1–24 installments',
    Remark: 'Remark',
    PlaceHolderRemark: 'Enter Remark',
    ListSaleOrder: {
      Headers: 'Sale Order',
      SelectSaleOrder: 'Select Sale Order',
      NotFoundSaleOrder: 'No Sale Order Found'
    },
    NameSaleOder: 'Sale Order Name',
    TypeOfCustomer: {
      Headers: 'Type of Customer',
      SelectTypeCustomer: 'Select Type of Customer',
      NotFoundTypeCustomer: 'No Type of Customer Found'
    },
    Button: {
      Save: 'Save',
      Next: 'Next',
      Cancel: 'Cancel',
      Confirm: 'Confirm',
      Back: 'Back'
    },
    VSelectCustomer: {
      general: 'General',
      business: 'Business'
    },
    Validate: {
      Validate1: 'Please enter your Tax ID',
      Validate2: 'Tax ID must be 13 digits',
      Validate3: 'Invalid taxpayer identification number',
      Validate4: 'Please enter customer name',
      Validate5: 'Customer name must not exceed 150 characters',
      Validate6: 'Please enter customer code',
      Validate7: 'Only English letters and numbers are allowed',
      Validate8: 'Please enter the taxpayer number',
      Validate9: 'Numbers only',
      Validate10: 'Please select information',
      Validate11: 'Please enter correct information',
      Validate12: 'Please enter phone number',
      Validate13: 'Phone number should start with 0',
      Validate14: 'Phone number must be more than 9 digits',
      Validate15: 'Please enter email address',
      Validate16: 'Please enter a valid email address',
      Validate17: 'English characters only',
      Validate18: 'Email must not contain spaces',
      Validate19: 'Please enter username',
      Validate20: 'Please enter information'
    },
    dialogConfirmmanageCustomerSale: {
      Text1: 'Do you want to ',
      Text2: '?',
      Text3: 'Customer added successfully',
      Text4: 'Customer updated successfully',
      Text5: 'You have successfully added the customer',
      Text6: 'You have successfully updated the customer'
    }
  },
  FriendGetFriends: {
    InviteFriends: 'Invite Friends',
    MyCode: 'My Code',
    Copy: 'Copy',
    InvitationCode: 'Invitation Code',
    EnterInvitationCode: 'Enter invite code',
    Confirm: 'Confirm',
    SelectInviteLine: 'Select invite tree line',
    CopySuccess: 'Copied successfully',
    PleaseEnterCode: 'Please enter invite code',
    PleaseEnterFriendCode: 'You cannot invite yourself',
    InvalidCode: 'Invalid invite code',
    CodeConfirmed: 'Invite code confirmed successfully'
  },
  MemberLevelUp: {
    close: 'Close dialog',
    silver: {
      title: 'Congratulations!',
      line1: 'You have been upgraded to {levelName} membership.',
      line2: 'Enjoy more benefits and earn points faster.'
    },
    gold: {
      title: 'Excellent!',
      line1: 'You have been upgraded to {levelName} membership.',
      line2: 'Enjoy premium privileges and exclusive offers.'
    },
    diamond: {
      title: 'Amazing!',
      line1: 'You have reached {levelName} membership.',
      line2: 'Enjoy the ultimate benefits and an exclusive experience.'
    }
  },
  Coin: {
    HeaderCoin: 'Get Coin',
    CollectCoin: 'Collect daily coins',
    TotalCoin: 'Total Coin',
    HistoryCoin: 'Coin collection history',
    NoHistory: 'There is no history of coin collection.'
  },
  OTPVerifyPage: {
    LoginWithOTP: 'Sign in with phone number',
    DescribeOTP: 'An OTP will be sent to your phone number.',
    PhoneOTP: 'Phone Number',
    EnterPhone: 'Enter Phone Number',
    ValidateOTP1: 'Please enter your phone number',
    ValidateOTP2: 'Please enter a 10-digit phone number',
    OTPNotRegister1: 'This phone number is not registered.',
    OTPNotRegister2: 'Do you want to register?',
    OTPFail: 'We’re unable to complete your request.',
    yes: 'Yes',
    no: 'No',
    OTPSend: 'An OTP has been sent to',
    ReferenceCode: 'Reference Code',
    ConfirmOTP: 'Confirm OTP'
  },
  MemberCoupon: {
    MaxDiscount: 'Up to',
    MinimumSpend: 'Min. spend',
    Used: 'Used',
    Remaining: 'Remaining',
    ValidUntil: 'Valid until',
    TermsAndConditions: 'Condition',
    FullyRedeemed: 'Fully redeemed',
    DiscountConditions: 'Discount Conditions',
    Discount: 'Discount',
    ShoppingDiscountCoupon: 'Shopping Discount Coupon',
    CouponDetails: 'Coupon Details',
    PromotionType: 'Promotion Type',
    GeneralDiscount: 'General Discount',
    BirthdayDiscount: 'Birthday Discount',
    ShippingDiscount: 'Shipping Discount',
    CreditLimit: 'Credit Limit',
    FreebieCoupon: 'Freebie Coupon',
    CouponUsageRights: 'Coupon Usage Rights',
    Rights: 'vouchers',
    MaximumDiscount: 'Maximum Discount',
    ParticipatingShops: 'Participating Shops',
    Shop: 'Shop',
    Shops: 'Shops',
    ValidForAllShops: 'Valid for All Shops',
    Bath: 'Bath',
    Unlimited: 'Unlimited',
    XGetY: 'Buy X Get Y',
    AvailableCoupons: 'Available Coupons',
    DiscountNameCoupon: 'Discount'
  },
  MyMember: {
    MyShops: 'My Shops',
    MembershipEnabledShops: 'Shops with Membership',
    Shop: '',
    ViewAll: 'View All',
    GoToShop: 'Go to Shop',
    MyBenefits: 'My Benefits',
    Discount: 'Discount',
    Minimum: 'Minimum',
    Maximum: 'Up to',
    ValidUntil: 'Valid Until',
    Unlimited: 'Unlimited',
    Used: 'Used',
    Remaining: 'Remaining',
    AllBenefits: 'All Benefits',
    TermsAndConditions: 'Conditions',
    ProductsForYouFromMemberShops: 'Member Shop Picks for You',
    Sold: '',
    Piece: 'Sold',
    ActivitiesAndNewsFromMyShops: 'Shop Activities / News',
    NoShopData: 'No shop data',
    NoShopActivityOrNews: 'No shop activity or news',
    NoPrivilegeData: 'No privilege data',
    NoMemberProductData: 'No member product data',
    ShippingDiscount: 'Shipping Discount',
    XGetY: 'Buy X Get Y',
    Greeting: 'Hello',
    MemberShops: 'Shops with Membership',
    ShopNow: 'Shop Now'
  },
  ShopRegister: {
    back: 'Back',
    login: 'Sign in',
    phone: 'Phone number',
    enterPhone: 'Enter phone number',
    accept: 'I accept the',
    terms: 'Terms of Use',
    and: 'and',
    privacy: 'Privacy Policy',
    or: 'or',
    usernameLogin: 'Sign in with username',
    noAccount: "Don't have an account?",
    register: 'Register',
    registerWithoutOtp: 'Register without OTP',
    hasAccount: 'Already have an account?',
    username: 'Username',
    enterUsername: 'Enter username',
    password: 'Password',
    enterPassword: 'Enter password',
    forgotPassword: 'Forgot password',
    verifyOtp: 'Verify OTP',
    sendingOtp: 'Sending OTP...',
    forgotPin: 'Forgot PIN',
    confirm: 'Confirm',
    verifyOtpForNewPin: 'Verify OTP to set a new PIN',
    otpSentTo: 'An OTP has been sent to',
    referenceCode: 'Reference code',
    otpRequestAgain: 'You can request another OTP in',
    otpNotReceived: "Didn't receive the code?",
    resendOtp: 'Resend OTP',
    setNewPin: 'Set a new PIN',
    setPin: 'Set PIN',
    confirmNewPin: 'Confirm new PIN',
    resetPinSuccess: 'New PIN set successfully',
    confirmPin: 'Confirm PIN',
    pinMismatch: 'PINs do not match. Please try again.',
    loading: 'Loading...',
    close: 'Close',
    loginSuccess: 'Signed in successfully!',
    duplicatePhoneTitle: 'This phone number is already in use',
    duplicatePhoneDescription: 'Please sign in with NexGen ID',
    loginFailed: 'Sign-in failed!',
    loginError: 'An error occurred while signing in!',
    loginWarningDescription: 'Check your sign-in details and try again.',
    loginErrorDescription: 'Unable to complete your request. Please try again.',
    missingOneIdPhoneTitle: 'Sign-in failed',
    contactStaff: 'Please contact support',
    unsupportedAccountType: 'This account type is not supported. Please try again.',
    requestFailed: 'Check your information and try again.',
    missingRegistrationToken: 'The access token required to register the NexGen ID was not found.',
    missingResetPinToken: 'The token required to reset the PIN was not found.',
    missingUserId: 'The user ID required to register the NexGen ID was not found.'
  },
  SpecialDeals: {
    Day: 'Day',
    SpecialDealsComingSoon: 'Special Deals coming soon',
    OrderNow: 'Order now',
    PurchaseLimitReached: 'Redemption limit reached',
    OutOfStock: 'Out of stock',
    SoldOut: 'Sold out'
  }
}
